// import React, { useState, useEffect } from "react";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "./Companydetails.css";

// const CompanyDetails = ({ user }) => {
//   const [categories, setCategories] = useState([]);
//   const [subcategories, setSubcategories] = useState([]);
//   const [companyData, setCompanyData] = useState(null);
//   const [formData, setFormData] = useState({
//     company_name: "",
//     company_address: "",
//     email: "",
//     mobile: "",
//     ceo_name: "",
//     description: "",
//     map_link: "",
//     website: "",
//     business_hours: "",
//     category: [],
//     subcategory: [],
//     other_contacts: [{ label: "", number: "" }],
//     social_media: [{ label: "", link: "" }],
//     images: [],
//     products: [{ text: "", image: null }],
//   });
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState("");
//   const [activeTab, setActiveTab] = useState("basic");
//   const [selectedCategories, setSelectedCategories] = useState([]);
//   const [selectedSubcategories, setSelectedSubcategories] = useState([]);
//   const [isEditing, setIsEditing] = useState(false);
//   const [hasCompany, setHasCompany] = useState(false);

//   // Fetch categories and subcategories on component mount
//   useEffect(() => {
//     fetchCategories();
//     fetchSubcategories();
//     fetchCompanyData();
//   }, []);

//   const fetchCategories = async () => {
//     try {
//       const response = await fetch(
//         "https://ambatturindustrialestate.com/api/api/categories/",
//       );
//       const data = await response.json();
//       setCategories(data);
//     } catch (error) {
//       console.error("Error fetching categories:", error);
//     }
//   };

//   const fetchSubcategories = async () => {
//     try {
//       const response = await fetch(
//         "https://ambatturindustrialestate.com/api/api/subcategories/",
//       );
//       const data = await response.json();
//       setSubcategories(data);
//     } catch (error) {
//       console.error("Error fetching subcategories:", error);
//     }
//   };

//   const fetchCompanyData = async () => {
//     try {
//       const token = localStorage.getItem("access");
//       const response = await fetch(
//         "https://ambatturindustrialestate.com/api/api/my-company/",
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         },
//       );

//       if (response.ok) {
//         const data = await response.json();

//         // Check if the response contains company data or an error message
//         if (data.detail && data.detail === "Company not found for this user.") {
//           // User doesn't have a company
//           setHasCompany(false);
//           setCompanyData(null);
//         } else if (data.id) {
//           // User has a company
//           setHasCompany(true);
//           setCompanyData(data);
//           initializeFormData(data);
//         } else {
//           console.error("Unexpected API response format:", data);
//           setHasCompany(false);
//           setCompanyData(null);
//         }
//       } else {
//         const errorData = await response.json();
//         if (errorData.detail === "Company not found for this user.") {
//           setHasCompany(false);
//           setCompanyData(null);
//         } else {
//           console.error("Failed to fetch company data:", errorData);
//           setHasCompany(false);
//           setCompanyData(null);
//         }
//       }
//     } catch (error) {
//       console.error("Error fetching company data:", error);
//       setHasCompany(false);
//       setCompanyData(null);
//     }
//   };

//   const initializeFormData = (data) => {
//     // Get category and subcategory names for display
//     const categoryNames =
//       data.related_companies && data.related_companies[0]
//         ? data.related_companies[0].category_name || []
//         : [];

//     const subcategoryNames =
//       data.related_companies && data.related_companies[0]
//         ? data.related_companies[0].category_name || [] // Adjust based on actual API structure
//         : [];

//     setFormData({
//       company_name: data.user?.company_name || "",
//       company_address: data.user?.company_address || "",
//       email: data.user?.email || "",
//       mobile: data.user?.mobile || "",
//       ceo_name: data.ceo_name || "",
//       description: data.description || "",
//       map_link: data.map_link || "",
//       website: data.website || "",
//       business_hours: data.business_hours || "",
//       category: data.category || [],
//       subcategory: data.subcategory || [],
//       other_contacts:
//         data.other_contacts && data.other_contacts.length > 0
//           ? data.other_contacts
//           : [{ label: "", number: "" }],
//       social_media:
//         data.social_media && data.social_media.length > 0
//           ? data.social_media
//           : [{ label: "", link: "" }],
//       images: data.images || [],
//       products:
//         data.products && data.products.length > 0
//           ? data.products
//           : [{ text: "", image: null }],
//     });

//     // Set selected categories and subcategories
//     setSelectedCategories(data.category || []);
//     setSelectedSubcategories(data.subcategory || []);
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]: value,
//     });
//   };

//   const handleCategoryChange = (e) => {
//     const options = e.target.options;
//     const newSelectedCategories = [];
//     for (let i = 0; i < options.length; i++) {
//       if (options[i].selected) {
//         newSelectedCategories.push(parseInt(options[i].value));
//       }
//     }
//     setSelectedCategories(newSelectedCategories);
//     setFormData({
//       ...formData,
//       category: newSelectedCategories,
//     });
//   };

//   const handleSubcategoryChange = (e) => {
//     const options = e.target.options;
//     const newSelectedSubcategories = [];
//     for (let i = 0; i < options.length; i++) {
//       if (options[i].selected) {
//         newSelectedSubcategories.push(parseInt(options[i].value));
//       }
//     }
//     setSelectedSubcategories(newSelectedSubcategories);
//     setFormData({
//       ...formData,
//       subcategory: newSelectedSubcategories,
//     });
//   };

//   const handleContactChange = (index, field, value) => {
//     const updatedContacts = [...formData.other_contacts];
//     updatedContacts[index][field] = value;

//     setFormData({
//       ...formData,
//       other_contacts: updatedContacts,
//     });
//   };

//   const addContactField = () => {
//     setFormData({
//       ...formData,
//       other_contacts: [...formData.other_contacts, { label: "", number: "" }],
//     });
//   };

//   const removeContactField = (index) => {
//     if (formData.other_contacts.length > 1) {
//       const updatedContacts = [...formData.other_contacts];
//       updatedContacts.splice(index, 1);

//       setFormData({
//         ...formData,
//         other_contacts: updatedContacts,
//       });
//     }
//   };

//   const handleSocialMediaChange = (index, field, value) => {
//     const updatedSocialMedia = [...formData.social_media];
//     updatedSocialMedia[index][field] = value;

//     setFormData({
//       ...formData,
//       social_media: updatedSocialMedia,
//     });
//   };

//   const addSocialMediaField = () => {
//     setFormData({
//       ...formData,
//       social_media: [...formData.social_media, { label: "", link: "" }],
//     });
//   };

//   const removeSocialMediaField = (index) => {
//     if (formData.social_media.length > 1) {
//       const updatedSocialMedia = [...formData.social_media];
//       updatedSocialMedia.splice(index, 1);

//       setFormData({
//         ...formData,
//         social_media: updatedSocialMedia,
//       });
//     }
//   };

//   const handleProductChange = (index, field, value) => {
//     const updatedProducts = [...formData.products];
//     updatedProducts[index][field] = value;

//     setFormData({
//       ...formData,
//       products: updatedProducts,
//     });
//   };

//   const addProductField = () => {
//     setFormData({
//       ...formData,
//       products: [...formData.products, { text: "", image: null }],
//     });
//   };

//   const removeProductField = (index) => {
//     if (formData.products.length > 1) {
//       const updatedProducts = [...formData.products];
//       updatedProducts.splice(index, 1);

//       setFormData({
//         ...formData,
//         products: updatedProducts,
//       });
//     }
//   };

//   const handleImageUpload = (e) => {
//     const files = e.target.files;
//     if (files.length > 0) {
//       console.log("Images to upload:", files);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (selectedCategories.length === 0) {
//       setMessage("Please select at least one category.");
//       setActiveTab("categories");
//       return;
//     }

//     setLoading(true);

//     try {
//       const token = localStorage.getItem("access");
//       const url =
//         hasCompany && companyData
//           ? `https://ambatturindustrialestate.com/api/api/companies-update&delete/${companyData.id}/`
//           : "https://ambatturindustrialestate.com/api/api/companies/add/";

//       const method = hasCompany && companyData ? "PUT" : "POST";

//       const requestData = {
//         company_name: formData.company_name,
//         company_address: formData.company_address,
//         email: formData.email,
//         mobile: formData.mobile,
//         ceo_name: formData.ceo_name,
//         description: formData.description,
//         map_link: formData.map_link,
//         website: formData.website,
//         business_hours: formData.business_hours,
//         category: selectedCategories,
//         subcategory: selectedSubcategories,
//         other_contacts: formData.other_contacts.filter(
//           (contact) => contact.label && contact.number,
//         ),
//         social_media: formData.social_media.filter((sm) => sm.label && sm.link),
//         products: formData.products.filter(
//           (product) => product.text || product.image,
//         ),
//       };

//       // Only include images if they exist
//       if (formData.images.length > 0) {
//         requestData.images = formData.images;
//       }

//       const response = await fetch(url, {
//         method: method,
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify(requestData),
//       });

//       if (response.ok) {
//         const successMessage = hasCompany
//           ? "Company details updated successfully!"
//           : "Company details added successfully!";
//         setMessage(successMessage);
//         fetchCompanyData();
//         setIsEditing(false);
//       } else {
//         const errorData = await response.json();
//         console.error("API Error:", errorData);
//         setMessage("Failed to update company details. Please try again.");
//       }
//     } catch (error) {
//       console.error("Error updating company:", error);
//       setMessage("An error occurred. Please try again.");
//     }

//     setLoading(false);
//   };

//   const handleDeleteCompany = async () => {
//     if (
//       window.confirm(
//         "Are you sure you want to delete your company details? This action cannot be undone.",
//       )
//     ) {
//       try {
//         const token = localStorage.getItem("access");
//         const response = await fetch(
//           `https://ambatturindustrialestate.com/api/api/companies/delete/${companyData.id}/`,
//           {
//             method: "DELETE",
//             headers: {
//               Authorization: `Bearer ${token}`,
//             },
//           },
//         );

//         if (response.ok) {
//           setMessage("Company details deleted successfully!");
//           setHasCompany(false);
//           setCompanyData(null);
//           resetFormData();
//         } else {
//           setMessage("Failed to delete company details. Please try again.");
//         }
//       } catch (error) {
//         console.error("Error deleting company:", error);
//         setMessage("An error occurred. Please try again.");
//       }
//     }
//   };

//   const resetFormData = () => {
//     setFormData({
//       company_name: "",
//       company_address: "",
//       email: "",
//       mobile: "",
//       ceo_name: "",
//       description: "",
//       map_link: "",
//       website: "",
//       business_hours: "",
//       category: [],
//       subcategory: [],
//       other_contacts: [{ label: "", number: "" }],
//       social_media: [{ label: "", link: "" }],
//       images: [],
//       products: [{ text: "", image: null }],
//     });
//     setSelectedCategories([]);
//     setSelectedSubcategories([]);
//   };

//   const handleEditToggle = () => {
//     if (isEditing && companyData) {
//       initializeFormData(companyData);
//     }
//     setIsEditing(!isEditing);
//   };

//   // Helper function to get category names for display
//   const getCategoryNames = () => {
//     if (!companyData?.category || !categories.length) return "None";

//     return companyData.category
//       .map((catId) => {
//         const category = categories.find((c) => c.category_id === catId);
//         return category ? category.name : null;
//       })
//       .filter(Boolean)
//       .join(", ");
//   };

//   // Helper function to get subcategory names for display
//   const getSubcategoryNames = () => {
//     if (!companyData?.subcategory || !subcategories.length) return "None";

//     return companyData.subcategory
//       .map((subId) => {
//         const subcategory = subcategories.find((s) => s.id === subId);
//         return subcategory ? subcategory.name : null;
//       })
//       .filter(Boolean)
//       .join(", ");
//   };

//   // If user has a company and we're not in edit mode, show the company details
//   if (hasCompany && companyData && !isEditing) {
//     return (
//       <div className="company-container container-fluid mt-4">
//         <div className="company-header row">
//           <div className="col-12">
//             <div className="company-header-content d-flex justify-content-between align-items-center mb-4">
//               <h1 className="company-title h2">Company Details</h1>
//               <div className="company-actions">
//                 <button className="company-btn company-btn-primary me-2">
//                   Preview Public Profile
//                 </button>
//                 <button
//                   className="company-btn company-btn-outline me-2"
//                   onClick={handleEditToggle}
//                 >
//                   Edit Details
//                 </button>
//                 <button
//                   className="company-btn company-btn-danger"
//                   onClick={handleDeleteCompany}
//                 >
//                   Delete Company
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>

//         {message && (
//           <div
//             className={`company-alert alert ${
//               message.includes("Please select") ? "alert-warning" : "alert-info"
//             } alert-dismissible fade show`}
//             role="alert"
//           >
//             {message}
//             <button
//               type="button"
//               className="btn-close"
//               onClick={() => setMessage("")}
//             ></button>
//           </div>
//         )}

//         <div className="company-card card">
//           <div className="company-card-header card-header">
//             <h5 className="company-card-title card-title mb-0">
//               Company Information
//             </h5>
//           </div>
//           <div className="company-card-body card-body">
//             <div className="company-profile row mb-4">
//               <div className="company-logo-section col-md-4 text-center">
//                 <img
//                   src="https://via.placeholder.com/150"
//                   className="company-logo img-fluid rounded mb-3"
//                   alt="Company Logo"
//                 />
//                 <div className="company-logo-actions d-grid gap-2">
//                   <button className="company-btn company-btn-outline">
//                     Upload New Logo
//                   </button>
//                 </div>
//               </div>
//               <div className="company-info col-md-8">
//                 <h3 className="company-name">
//                   {companyData.user?.company_name}
//                 </h3>
//                 <p className="company-description text-muted">
//                   {companyData.description || "No description provided"}
//                 </p>

//                 <div className="company-details row mt-4">
//                   <div className="company-contact col-md-6">
//                     <h6 className="company-section-title">
//                       Contact Information
//                     </h6>
//                     <p className="company-contact-info">
//                       <strong>CEO:</strong> {companyData.ceo_name || "N/A"}
//                       <br />
//                       <strong>Email:</strong> {companyData.user?.email || "N/A"}
//                       <br />
//                       <strong>Phone:</strong>{" "}
//                       {companyData.user?.mobile || "N/A"}
//                       <br />
//                       <strong>Address:</strong>{" "}
//                       {companyData.user?.company_address || "N/A"}
//                     </p>

//                     <h6 className="company-section-title mt-3">
//                       Website & Hours
//                     </h6>
//                     <p className="company-website-hours">
//                       <strong>Website:</strong> {companyData.website || "N/A"}
//                       <br />
//                       <strong>Business Hours:</strong>{" "}
//                       {companyData.business_hours || "N/A"}
//                     </p>
//                   </div>
//                   <div className="company-categories col-md-6">
//                     <h6 className="company-section-title">Categories</h6>
//                     <p className="company-categories-info">
//                       <strong>Main Categories:</strong> {getCategoryNames()}
//                       <br />
//                       <strong>Subcategories:</strong> {getSubcategoryNames()}
//                     </p>

//                     <h6 className="company-section-title mt-3">
//                       Additional Contacts
//                     </h6>
//                     {companyData.other_contacts &&
//                     companyData.other_contacts.length > 0 ? (
//                       companyData.other_contacts.map((contact, index) => (
//                         <p key={index} className="company-additional-contact">
//                           <strong>{contact.label}:</strong> {contact.number}
//                         </p>
//                       ))
//                     ) : (
//                       <p>No additional contacts</p>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="company-extras row">
//               <div className="company-social col-md-6">
//                 <h6 className="company-section-title">Social Media</h6>
//                 {companyData.social_media &&
//                 companyData.social_media.length > 0 ? (
//                   companyData.social_media.map((social, index) => (
//                     <p key={index} className="company-social-item">
//                       <strong>{social.label}:</strong>{" "}
//                       <a
//                         href={social.link}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         {social.link}
//                       </a>
//                     </p>
//                   ))
//                 ) : (
//                   <p>No social media links</p>
//                 )}
//               </div>
//               <div className="company-products col-md-6">
//                 <h6 className="company-section-title">Products/Services</h6>
//                 {companyData.products && companyData.products.length > 0 ? (
//                   companyData.products.map((product, index) => (
//                     <p key={index} className="company-product-item">
//                       <strong>Product {index + 1}:</strong> {product.text}
//                     </p>
//                   ))
//                 ) : (
//                   <p>No products/services listed</p>
//                 )}
//               </div>
//             </div>

//             {companyData.map_link && (
//               <div className="company-map mt-4">
//                 <h6 className="company-section-title">Location</h6>
//                 <div className="ratio ratio-16x9">
//                   <iframe
//                     src={companyData.map_link}
//                     style={{ border: 0 }}
//                     allowFullScreen=""
//                     loading="lazy"
//                     referrerPolicy="no-referrer-when-downgrade"
//                     title="Company Location"
//                   ></iframe>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // If user doesn't have a company or is in edit mode, show the form
//   return (
//     <div className="company-container container-fluid mt-4">
//       <div className="company-header row">
//         <div className="col-12">
//           <div className="company-header-content d-flex justify-content-between align-items-center mb-4">
//             <h1 className="company-title h2">
//               {hasCompany ? "Edit Company Details" : "Add Company Details"}
//             </h1>
//             {hasCompany && (
//               <button
//                 className="company-btn company-btn-secondary"
//                 onClick={handleEditToggle}
//               >
//                 Cancel Edit
//               </button>
//             )}
//           </div>
//         </div>
//       </div>

//       {message && (
//         <div
//           className={`company-alert alert ${
//             message.includes("Please select") ? "alert-warning" : "alert-info"
//           } alert-dismissible fade show`}
//           role="alert"
//         >
//           {message}
//           <button
//             type="button"
//             className="btn-close"
//             onClick={() => setMessage("")}
//           ></button>
//         </div>
//       )}

//       <div className="company-form row">
//         <div className="company-sidebar col-md-3">
//           <div className="company-nav-card card">
//             <div className="company-nav-header card-header">
//               <h5 className="company-nav-title card-title mb-0">Navigation</h5>
//             </div>
//             <div className="company-nav-list list-group list-group-flush">
//               <button
//                 className={`company-nav-item list-group-item list-group-item-action ${
//                   activeTab === "basic" ? "active" : ""
//                 }`}
//                 onClick={() => setActiveTab("basic")}
//               >
//                 Basic Information
//               </button>
//               <button
//                 className={`company-nav-item list-group-item list-group-item-action ${
//                   activeTab === "categories" ? "active" : ""
//                 }`}
//                 onClick={() => setActiveTab("categories")}
//               >
//                 Categories
//               </button>
//               <button
//                 className={`company-nav-item list-group-item list-group-item-action ${
//                   activeTab === "contacts" ? "active" : ""
//                 }`}
//                 onClick={() => setActiveTab("contacts")}
//               >
//                 Additional Contacts
//               </button>
//               <button
//                 className={`company-nav-item list-group-item list-group-item-action ${
//                   activeTab === "social" ? "active" : ""
//                 }`}
//                 onClick={() => setActiveTab("social")}
//               >
//                 Social Media
//               </button>
//               <button
//                 className={`company-nav-item list-group-item list-group-item-action ${
//                   activeTab === "products" ? "active" : ""
//                 }`}
//                 onClick={() => setActiveTab("products")}
//               >
//                 Products
//               </button>
//             </div>
//           </div>

//           <div className="company-logo-card card mt-4">
//             <div className="company-logo-header card-header">
//               <h5 className="company-logo-title card-title mb-0">
//                 Company Logo
//               </h5>
//             </div>
//             <div className="company-logo-body card-body text-center">
//               <div className="company-logo-preview mb-3">
//                 <img
//                   src="https://via.placeholder.com/150"
//                   className="company-logo img-fluid rounded"
//                   alt="Company Logo"
//                 />
//               </div>
//               <div className="company-logo-actions d-grid gap-2">
//                 <button className="company-btn company-btn-outline">
//                   Upload New Logo
//                 </button>
//                 <button className="company-btn company-btn-danger">
//                   Remove Logo
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="company-form-content col-md-9">
//           <div className="company-form-card card">
//             <div className="company-form-header card-header">
//               <h5 className="company-form-title card-title mb-0">
//                 {activeTab === "basic" && "Basic Information"}
//                 {activeTab === "categories" && "Categories & Subcategories"}
//                 {activeTab === "contacts" && "Additional Contacts"}
//                 {activeTab === "social" && "Social Media Links"}
//                 {activeTab === "products" && "Products"}
//               </h5>
//             </div>
//             <div className="company-form-body card-body">
//               <form onSubmit={handleSubmit}>
//                 {/* Basic Information Tab */}
//                 {activeTab === "basic" && (
//                   <div className="company-tab-content">
//                     <div className="company-form-row row mb-3">
//                       <div className="col-md-6">
//                         <label
//                           htmlFor="company_name"
//                           className="company-form-label form-label"
//                         >
//                           Company Name *
//                         </label>
//                         <input
//                           type="text"
//                           className="company-form-input form-control"
//                           id="company_name"
//                           name="company_name"
//                           value={formData.company_name}
//                           onChange={handleChange}
//                           required
//                         />
//                       </div>
//                       <div className="col-md-6">
//                         <label
//                           htmlFor="ceo_name"
//                           className="company-form-label form-label"
//                         >
//                           CEO Name
//                         </label>
//                         <input
//                           type="text"
//                           className="company-form-input form-control"
//                           id="ceo_name"
//                           name="ceo_name"
//                           value={formData.ceo_name}
//                           onChange={handleChange}
//                         />
//                       </div>
//                     </div>

//                     <div className="company-form-row row mb-3">
//                       <div className="col-md-6">
//                         <label
//                           htmlFor="email"
//                           className="company-form-label form-label"
//                         >
//                           Email *
//                         </label>
//                         <input
//                           type="email"
//                           className="company-form-input form-control"
//                           id="email"
//                           name="email"
//                           value={formData.email}
//                           onChange={handleChange}
//                           required
//                         />
//                       </div>
//                       <div className="col-md-6">
//                         <label
//                           htmlFor="mobile"
//                           className="company-form-label form-label"
//                         >
//                           Phone *
//                         </label>
//                         <input
//                           type="text"
//                           className="company-form-input form-control"
//                           id="mobile"
//                           name="mobile"
//                           value={formData.mobile}
//                           onChange={handleChange}
//                           required
//                         />
//                       </div>
//                     </div>

//                     <div className="company-form-field mb-3">
//                       <label
//                         htmlFor="company_address"
//                         className="company-form-label form-label"
//                       >
//                         Address *
//                       </label>
//                       <input
//                         type="text"
//                         className="company-form-input form-control"
//                         id="company_address"
//                         name="company_address"
//                         value={formData.company_address}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>

//                     <div className="company-form-row row mb-3">
//                       <div className="col-md-6">
//                         <label
//                           htmlFor="website"
//                           className="company-form-label form-label"
//                         >
//                           Website
//                         </label>
//                         <input
//                           type="text"
//                           className="company-form-input form-control"
//                           id="website"
//                           name="website"
//                           value={formData.website}
//                           onChange={handleChange}
//                           placeholder="https://example.com"
//                         />
//                       </div>
//                       <div className="col-md-6">
//                         <label
//                           htmlFor="business_hours"
//                           className="company-form-label form-label"
//                         >
//                           Business Hours
//                         </label>
//                         <input
//                           type="text"
//                           className="company-form-input form-control"
//                           id="business_hours"
//                           name="business_hours"
//                           value={formData.business_hours}
//                           onChange={handleChange}
//                           placeholder="Mon-Fri 9AM-6PM"
//                         />
//                       </div>
//                     </div>

//                     <div className="company-form-field mb-3">
//                       <label
//                         htmlFor="map_link"
//                         className="company-form-label form-label"
//                       >
//                         Map Link
//                       </label>
//                       <input
//                         type="text"
//                         className="company-form-input form-control"
//                         id="map_link"
//                         name="map_link"
//                         value={formData.map_link}
//                         onChange={handleChange}
//                         placeholder="https://maps.google.com/?q=your+address"
//                       />
//                     </div>

//                     <div className="company-form-field mb-3">
//                       <label
//                         htmlFor="description"
//                         className="company-form-label form-label"
//                       >
//                         Company Description
//                       </label>
//                       <textarea
//                         className="company-form-textarea form-control"
//                         id="description"
//                         name="description"
//                         rows="4"
//                         value={formData.description}
//                         onChange={handleChange}
//                         placeholder="Describe your company and services..."
//                       ></textarea>
//                     </div>
//                   </div>
//                 )}

//                 {/* Categories Tab */}
//                 {activeTab === "categories" && (
//                   <div className="company-tab-content">
//                     <div className="company-alert alert alert-info mb-3">
//                       <i className="bi bi-info-circle"></i> Please select at
//                       least one category. Use Ctrl/Cmd to select multiple
//                       options.
//                     </div>
//                     <div className="company-form-row row mb-3">
//                       <div className="col-md-6">
//                         <label
//                           htmlFor="category"
//                           className="company-form-label form-label"
//                         >
//                           Categories *
//                         </label>
//                         <select
//                           multiple
//                           className="company-form-select form-control"
//                           id="category"
//                           name="category"
//                           value={selectedCategories}
//                           onChange={handleCategoryChange}
//                           required
//                           size="5"
//                         >
//                           {categories.map((cat) => (
//                             <option
//                               key={cat.category_id}
//                               value={cat.category_id}
//                             >
//                               {cat.name}
//                             </option>
//                           ))}
//                         </select>
//                         <small className="company-form-help form-text text-muted">
//                           Hold Ctrl/Cmd to select multiple categories
//                         </small>
//                       </div>
//                       <div className="col-md-6">
//                         <label
//                           htmlFor="subcategory"
//                           className="company-form-label form-label"
//                         >
//                           Subcategories
//                         </label>
//                         <select
//                           multiple
//                           className="company-form-select form-control"
//                           id="subcategory"
//                           name="subcategory"
//                           value={selectedSubcategories}
//                           onChange={handleSubcategoryChange}
//                           size="5"
//                         >
//                           {subcategories.map((sub) => (
//                             <option key={sub.id} value={sub.id}>
//                               {sub.name}
//                             </option>
//                           ))}
//                         </select>
//                         <small className="company-form-help form-text text-muted">
//                           Hold Ctrl/Cmd to select multiple subcategories
//                         </small>
//                       </div>
//                     </div>
//                     <div className="company-alert alert alert-info">
//                       <i className="bi bi-info-circle"></i> Selected Categories:{" "}
//                       {selectedCategories
//                         .map((id) => {
//                           const cat = categories.find(
//                             (c) => c.category_id === id,
//                           );
//                           return cat ? cat.name : null;
//                         })
//                         .filter(Boolean)
//                         .join(", ") || "None"}
//                     </div>
//                     <div className="company-alert alert alert-info">
//                       <i className="bi bi-info-circle"></i> Selected
//                       Subcategories:{" "}
//                       {selectedSubcategories
//                         .map((id) => {
//                           const sub = subcategories.find((s) => s.id === id);
//                           return sub ? sub.name : null;
//                         })
//                         .filter(Boolean)
//                         .join(", ") || "None"}
//                     </div>
//                   </div>
//                 )}

//                 {/* Additional Contacts Tab */}
//                 {activeTab === "contacts" && (
//                   <div className="company-tab-content">
//                     <div className="company-form-field mb-3">
//                       <label className="company-form-label form-label">
//                         Additional Contact Numbers
//                       </label>
//                       {formData.other_contacts.map((contact, index) => (
//                         <div
//                           key={index}
//                           className="company-contact-field row mb-2"
//                         >
//                           <div className="col-md-5">
//                             <input
//                               type="text"
//                               className="company-form-input form-control"
//                               placeholder="Label (e.g., Support, Sales)"
//                               value={contact.label}
//                               onChange={(e) =>
//                                 handleContactChange(
//                                   index,
//                                   "label",
//                                   e.target.value,
//                                 )
//                               }
//                             />
//                           </div>
//                           <div className="col-md-5">
//                             <input
//                               type="text"
//                               className="company-form-input form-control"
//                               placeholder="Phone number"
//                               value={contact.number}
//                               onChange={(e) =>
//                                 handleContactChange(
//                                   index,
//                                   "number",
//                                   e.target.value,
//                                 )
//                               }
//                             />
//                           </div>
//                           <div className="col-md-2">
//                             <button
//                               type="button"
//                               className="company-btn company-btn-danger w-100"
//                               onClick={() => removeContactField(index)}
//                               disabled={formData.other_contacts.length <= 1}
//                             >
//                               Remove
//                             </button>
//                           </div>
//                         </div>
//                       ))}
//                       <button
//                         type="button"
//                         className="company-btn company-btn-outline mt-2"
//                         onClick={addContactField}
//                       >
//                         + Add Another Contact
//                       </button>
//                     </div>
//                   </div>
//                 )}

//                 {/* Social Media Tab */}
//                 {activeTab === "social" && (
//                   <div className="company-tab-content">
//                     <div className="company-form-field mb-3">
//                       <label className="company-form-label form-label">
//                         Social Media Links
//                       </label>
//                       {formData.social_media.map((social, index) => (
//                         <div
//                           key={index}
//                           className="company-social-field row mb-2"
//                         >
//                           <div className="col-md-5">
//                             <select
//                               className="company-form-select form-control"
//                               value={social.label}
//                               onChange={(e) =>
//                                 handleSocialMediaChange(
//                                   index,
//                                   "label",
//                                   e.target.value,
//                                 )
//                               }
//                             >
//                               <option value="">Select Platform</option>
//                               <option value="Facebook">Facebook</option>
//                               <option value="LinkedIn">LinkedIn</option>
//                               <option value="Twitter">Twitter</option>
//                               <option value="Instagram">Instagram</option>
//                               <option value="YouTube">YouTube</option>
//                             </select>
//                           </div>
//                           <div className="col-md-5">
//                             <input
//                               type="text"
//                               className="company-form-input form-control"
//                               placeholder="Profile URL"
//                               value={social.link}
//                               onChange={(e) =>
//                                 handleSocialMediaChange(
//                                   index,
//                                   "link",
//                                   e.target.value,
//                                 )
//                               }
//                             />
//                           </div>
//                           <div className="col-md-2">
//                             <button
//                               type="button"
//                               className="company-btn company-btn-danger w-100"
//                               onClick={() => removeSocialMediaField(index)}
//                               disabled={formData.social_media.length <= 1}
//                             >
//                               Remove
//                             </button>
//                           </div>
//                         </div>
//                       ))}
//                       <button
//                         type="button"
//                         className="company-btn company-btn-outline mt-2"
//                         onClick={addSocialMediaField}
//                       >
//                         + Add Another Social Media
//                       </button>
//                     </div>
//                   </div>
//                 )}

//                 {/* Products Tab */}
//                 {activeTab === "products" && (
//                   <div className="company-tab-content">
//                     <div className="company-form-field mb-3">
//                       <label className="company-form-label form-label">
//                         Products/Services
//                       </label>
//                       {formData.products.map((product, index) => (
//                         <div
//                           key={index}
//                           className="company-product-card card mb-3"
//                         >
//                           <div className="company-product-body card-body">
//                             <div className="company-product-row row mb-2">
//                               <div className="col-md-10">
//                                 <label className="company-form-label form-label">
//                                   Product Description
//                                 </label>
//                                 <textarea
//                                   className="company-form-textarea form-control"
//                                   rows="2"
//                                   placeholder="Describe your product or service..."
//                                   value={product.text}
//                                   onChange={(e) =>
//                                     handleProductChange(
//                                       index,
//                                       "text",
//                                       e.target.value,
//                                     )
//                                   }
//                                 ></textarea>
//                               </div>
//                               <div className="col-md-2 d-flex align-items-end">
//                                 <button
//                                   type="button"
//                                   className="company-btn company-btn-danger w-100"
//                                   onClick={() => removeProductField(index)}
//                                   disabled={formData.products.length <= 1}
//                                 >
//                                   Remove
//                                 </button>
//                               </div>
//                             </div>
//                             <div className="company-product-row row">
//                               <div className="col-md-12">
//                                 <label className="company-form-label form-label">
//                                   Product Image
//                                 </label>
//                                 <input
//                                   type="file"
//                                   className="company-form-input form-control"
//                                   accept="image/*"
//                                   onChange={(e) =>
//                                     handleProductChange(
//                                       index,
//                                       "image",
//                                       e.target.files[0],
//                                     )
//                                   }
//                                 />
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       ))}
//                       <button
//                         type="button"
//                         className="company-btn company-btn-outline mt-2"
//                         onClick={addProductField}
//                       >
//                         + Add Another Product
//                       </button>
//                     </div>
//                   </div>
//                 )}

//                 <div className="company-form-actions d-flex justify-content-between mt-4">
//                   <div>
//                     {activeTab !== "basic" && (
//                       <button
//                         type="button"
//                         className="company-btn company-btn-secondary me-2"
//                         onClick={() => {
//                           const tabs = [
//                             "basic",
//                             "categories",
//                             "contacts",
//                             "social",
//                             "products",
//                           ];
//                           const currentIndex = tabs.indexOf(activeTab);
//                           if (currentIndex > 0)
//                             setActiveTab(tabs[currentIndex - 1]);
//                         }}
//                       >
//                         Previous
//                       </button>
//                     )}
//                     {activeTab !== "products" && (
//                       <button
//                         type="button"
//                         className="company-btn company-btn-primary"
//                         onClick={() => {
//                           const tabs = [
//                             "basic",
//                             "categories",
//                             "contacts",
//                             "social",
//                             "products",
//                           ];
//                           const currentIndex = tabs.indexOf(activeTab);
//                           if (currentIndex < tabs.length - 1)
//                             setActiveTab(tabs[currentIndex + 1]);
//                         }}
//                       >
//                         Next
//                       </button>
//                     )}
//                   </div>
//                   <button
//                     type="submit"
//                     className="company-btn company-btn-success"
//                     disabled={loading}
//                   >
//                     {loading
//                       ? "Saving..."
//                       : hasCompany
//                         ? "Update Company"
//                         : "Add Company"}
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CompanyDetails;

// import React, { useState, useEffect } from "react";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "./Companydetails.css";

// const CompanyDetails = ({ user }) => {
//   const [categories, setCategories] = useState([]);
//   const [subcategories, setSubcategories] = useState([]);
//   const [companyData, setCompanyData] = useState(null);
//   const [formData, setFormData] = useState({
//     company_name: "",
//     company_address: "",
//     email: "",
//     mobile: "",
//     ceo_name: "",
//     description: "",
//     map_link: "",
//     website: "",
//     business_hours: "",
//     category: [],
//     subcategory: [],
//     other_contacts: [{ label: "", number: "" }],
//     social_media: [{ label: "", link: "" }],
//     images: [],
//     products: [{ text: "", image: null }],
//     ceo_image: null,
//     ceo_mobile: "",
//     ceo_mail: "",
//     contact_person_name: "",
//     contact_person_mobile: "",
//     contact_person_mail: "",
//     related_companies: [],
//   });
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState("");
//   const [activeTab, setActiveTab] = useState("basic");
//   const [selectedCategories, setSelectedCategories] = useState([]);
//   const [selectedSubcategories, setSelectedSubcategories] = useState([]);
//   const [isEditing, setIsEditing] = useState(false);
//   const [hasCompany, setHasCompany] = useState(false);
//   const [imagePreviews, setImagePreviews] = useState([]);

//   // Fetch categories and subcategories on component mount
//   useEffect(() => {
//     fetchCategories();
//     fetchSubcategories();
//     fetchCompanyData();
//   }, []);

//   const fetchCategories = async () => {
//     try {
//       const response = await fetch(
//         "https://ambatturindustrialestate.com/api/api/categories/",
//       );
//       const data = await response.json();
//       setCategories(data);
//     } catch (error) {
//       console.error("Error fetching categories:", error);
//     }
//   };

//   const fetchSubcategories = async () => {
//     try {
//       const response = await fetch(
//         "https://ambatturindustrialestate.com/api/api/subcategories/",
//       );
//       const data = await response.json();
//       setSubcategories(data);
//     } catch (error) {
//       console.error("Error fetching subcategories:", error);
//     }
//   };

//   const fetchCompanyData = async () => {
//     try {
//       const token = localStorage.getItem("access");
//       const response = await fetch(
//         "https://ambatturindustrialestate.com/api/api/my-company/",
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         },
//       );

//       if (response.ok) {
//         const data = await response.json();

//         // Check if the response contains company data or an error message
//         if (data.detail && data.detail === "Company not found for this user.") {
//           // User doesn't have a company
//           setHasCompany(false);
//           setCompanyData(null);
//         } else if (data.id) {
//           // User has a company
//           setHasCompany(true);
//           setCompanyData(data);
//           initializeFormData(data);
//         } else {
//           console.error("Unexpected API response format:", data);
//           setHasCompany(false);
//           setCompanyData(null);
//         }
//       } else {
//         const errorData = await response.json();
//         if (errorData.detail === "Company not found for this user.") {
//           setHasCompany(false);
//           setCompanyData(null);
//         } else {
//           console.error("Failed to fetch company data:", errorData);
//           setHasCompany(false);
//           setCompanyData(null);
//         }
//       }
//     } catch (error) {
//       console.error("Error fetching company data:", error);
//       setHasCompany(false);
//       setCompanyData(null);
//     }
//   };

//   const initializeFormData = (data) => {
//     // Format other_contacts to ensure proper structure
//     const formattedContacts =
//       data.other_contacts && data.other_contacts.length > 0
//         ? data.other_contacts.map((contact) => ({
//             label: contact.label || "",
//             number: contact.number || "",
//           }))
//         : [{ label: "", number: "" }];

//     // Format social_media to ensure proper structure
//     const formattedSocialMedia =
//       data.social_media && data.social_media.length > 0
//         ? data.social_media.map((social) => ({
//             label: social.label || "",
//             link: social.link || "",
//           }))
//         : [{ label: "", link: "" }];

//     // Format products to ensure proper structure
//     const formattedProducts =
//       data.products && data.products.length > 0
//         ? data.products.map((product) => ({
//             text: product.text || "",
//             image: product.image || null,
//           }))
//         : [{ text: "", image: null }];

//     setFormData({
//       company_name: data.user?.company_name || "",
//       company_address: data.user?.company_address || "",
//       email: data.user?.email || "",
//       mobile: data.user?.mobile || "",
//       ceo_name: data.ceo_name || "",
//       description: data.description || "",
//       map_link: data.map_link || "",
//       website: data.website || "",
//       business_hours: data.business_hours || "",
//       category: data.category || [],
//       subcategory: data.subcategory || [],
//       other_contacts: formattedContacts,
//       social_media: formattedSocialMedia,
//       images: data.images || [],
//       products: formattedProducts,
//       ceo_image: data.ceo_image || null,
//       ceo_mobile: data.ceo_mobile || "",
//       ceo_mail: data.ceo_mail || "",
//       contact_person_name: data.contact_person_name || "",
//       contact_person_mobile: data.contact_person_mobile || "",
//       contact_person_mail: data.contact_person_mail || "",
//       related_companies: data.related_companies || [],
//     });

//     // Set selected categories and subcategories
//     setSelectedCategories(data.category || []);
//     setSelectedSubcategories(data.subcategory || []);
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]: value,
//     });
//   };

//   const handleCategoryChange = (e) => {
//     const options = e.target.options;
//     const newSelectedCategories = [];
//     for (let i = 0; i < options.length; i++) {
//       if (options[i].selected) {
//         newSelectedCategories.push(parseInt(options[i].value));
//       }
//     }
//     setSelectedCategories(newSelectedCategories);
//     setFormData({
//       ...formData,
//       category: newSelectedCategories,
//     });
//   };

//   const handleSubcategoryChange = (e) => {
//     const options = e.target.options;
//     const newSelectedSubcategories = [];
//     for (let i = 0; i < options.length; i++) {
//       if (options[i].selected) {
//         newSelectedSubcategories.push(parseInt(options[i].value));
//       }
//     }
//     setSelectedSubcategories(newSelectedSubcategories);
//     setFormData({
//       ...formData,
//       subcategory: newSelectedSubcategories,
//     });
//   };

//   const handleContactChange = (index, field, value) => {
//     const updatedContacts = [...formData.other_contacts];
//     updatedContacts[index][field] = value;

//     setFormData({
//       ...formData,
//       other_contacts: updatedContacts,
//     });
//   };

//   const addContactField = () => {
//     setFormData({
//       ...formData,
//       other_contacts: [...formData.other_contacts, { label: "", number: "" }],
//     });
//   };

//   const removeContactField = (index) => {
//     if (formData.other_contacts.length > 1) {
//       const updatedContacts = [...formData.other_contacts];
//       updatedContacts.splice(index, 1);

//       setFormData({
//         ...formData,
//         other_contacts: updatedContacts,
//       });
//     }
//   };

//   const handleSocialMediaChange = (index, field, value) => {
//     const updatedSocialMedia = [...formData.social_media];
//     updatedSocialMedia[index][field] = value;

//     setFormData({
//       ...formData,
//       social_media: updatedSocialMedia,
//     });
//   };

//   const addSocialMediaField = () => {
//     setFormData({
//       ...formData,
//       social_media: [...formData.social_media, { label: "", link: "" }],
//     });
//   };

//   const removeSocialMediaField = (index) => {
//     if (formData.social_media.length > 1) {
//       const updatedSocialMedia = [...formData.social_media];
//       updatedSocialMedia.splice(index, 1);

//       setFormData({
//         ...formData,
//         social_media: updatedSocialMedia,
//       });
//     }
//   };

//   const handleProductChange = (index, field, value) => {
//     const updatedProducts = [...formData.products];
//     if (field === "image") {
//       updatedProducts[index][field] = value;
//     } else {
//       updatedProducts[index][field] = value;
//     }

//     setFormData({
//       ...formData,
//       products: updatedProducts,
//     });
//   };

//   const addProductField = () => {
//     setFormData({
//       ...formData,
//       products: [...formData.products, { text: "", image: null }],
//     });
//   };

//   const removeProductField = (index) => {
//     if (formData.products.length > 1) {
//       const updatedProducts = [...formData.products];
//       updatedProducts.splice(index, 1);

//       setFormData({
//         ...formData,
//         products: updatedProducts,
//       });
//     }
//   };

//   const handleImageUpload = async (e, field) => {
//     const files = e.target.files;
//     if (files.length > 0) {
//       const file = files[0];

//       // Create preview
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         if (field === "images") {
//           setImagePreviews([...imagePreviews, e.target.result]);
//           setFormData({
//             ...formData,
//             images: [...formData.images, file],
//           });
//         } else if (field === "ceo_image") {
//           setFormData({
//             ...formData,
//             ceo_image: file,
//           });
//         }
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const removeImage = (index) => {
//     const updatedImages = [...formData.images];
//     updatedImages.splice(index, 1);

//     const updatedPreviews = [...imagePreviews];
//     updatedPreviews.splice(index, 1);

//     setImagePreviews(updatedPreviews);
//     setFormData({
//       ...formData,
//       images: updatedImages,
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (selectedCategories.length === 0) {
//       setMessage("Please select at least one category.");
//       setActiveTab("categories");
//       return;
//     }

//     setLoading(true);
//     setMessage("");

//     try {
//       const token = localStorage.getItem("access");
//       const url =
//         hasCompany && companyData
//           ? `https://ambatturindustrialestate.com/api/api/companies-update&delete/${companyData.id}/`
//           : "https://ambatturindustrialestate.com/api/api/companies/add/";

//       const method = hasCompany && companyData ? "PUT" : "POST";

//       // Create FormData to handle file uploads
//       const formDataToSend = new FormData();

//       // Add all text fields
//       formDataToSend.append("company_name", formData.company_name);
//       formDataToSend.append("company_address", formData.company_address);
//       formDataToSend.append("email", formData.email);
//       formDataToSend.append("mobile", formData.mobile);
//       formDataToSend.append("ceo_name", formData.ceo_name);
//       formDataToSend.append("description", formData.description);
//       formDataToSend.append("map_link", formData.map_link);
//       formDataToSend.append("website", formData.website);
//       formDataToSend.append("business_hours", formData.business_hours);
//       formDataToSend.append("ceo_mobile", formData.ceo_mobile);
//       formDataToSend.append("ceo_mail", formData.ceo_mail);
//       formDataToSend.append(
//         "contact_person_name",
//         formData.contact_person_name,
//       );
//       formDataToSend.append(
//         "contact_person_mobile",
//         formData.contact_person_mobile,
//       );
//       formDataToSend.append(
//         "contact_person_mail",
//         formData.contact_person_mail,
//       );

//       // Add arrays
//       selectedCategories.forEach((cat) => {
//         formDataToSend.append("category", cat);
//       });

//       selectedSubcategories.forEach((sub) => {
//         formDataToSend.append("subcategory", sub);
//       });

//       // Add other_contacts as JSON string
//       const filteredContacts = formData.other_contacts.filter(
//         (contact) => contact.label && contact.number,
//       );
//       formDataToSend.append("other_contacts", JSON.stringify(filteredContacts));

//       // Add social_media as JSON string
//       const filteredSocialMedia = formData.social_media.filter(
//         (social) => social.label && social.link,
//       );
//       formDataToSend.append(
//         "social_media",
//         JSON.stringify(filteredSocialMedia),
//       );

//       // Add products as JSON string (handling images separately)
//       const productsData = formData.products.map((product) => ({
//         text: product.text,
//         image: product.image && product.image.name ? product.image.name : null,
//       }));
//       formDataToSend.append("products", JSON.stringify(productsData));

//       // Add CEO image if exists
//       if (formData.ceo_image) {
//         formDataToSend.append("ceo_image", formData.ceo_image);
//       }

//       // Add product images
//       formData.products.forEach((product, index) => {
//         if (product.image && product.image instanceof File) {
//           formDataToSend.append(`product_image_${index}`, product.image);
//         }
//       });

//       // Add company images
//       formData.images.forEach((image, index) => {
//         if (image instanceof File) {
//           formDataToSend.append(`images`, image);
//         }
//       });

//       const response = await fetch(url, {
//         method: method,
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//         body: formDataToSend,
//       });

//       if (response.ok) {
//         const result = await response.json();
//         const successMessage = hasCompany
//           ? "Company details updated successfully!"
//           : "Company details added successfully!";
//         setMessage(successMessage);
//         fetchCompanyData();
//         setIsEditing(false);
//       } else {
//         const errorData = await response.json();
//         console.error("API Error:", errorData);
//         setMessage("Failed to update company details. Please try again.");
//       }
//     } catch (error) {
//       console.error("Error updating company:", error);
//       setMessage("An error occurred. Please try again.");
//     }

//     setLoading(false);
//   };

//   const handleDeleteCompany = async () => {
//     if (
//       window.confirm(
//         "Are you sure you want to delete your company details? This action cannot be undone.",
//       )
//     ) {
//       try {
//         const token = localStorage.getItem("access");
//         const response = await fetch(
//           `https://ambatturindustrialestate.com/api/api/companies/delete/${companyData.id}/`,
//           {
//             method: "DELETE",
//             headers: {
//               Authorization: `Bearer ${token}`,
//             },
//           },
//         );

//         if (response.ok) {
//           setMessage("Company details deleted successfully!");
//           setHasCompany(false);
//           setCompanyData(null);
//           resetFormData();
//         } else {
//           setMessage("Failed to delete company details. Please try again.");
//         }
//       } catch (error) {
//         console.error("Error deleting company:", error);
//         setMessage("An error occurred. Please try again.");
//       }
//     }
//   };

//   const resetFormData = () => {
//     setFormData({
//       company_name: "",
//       company_address: "",
//       email: "",
//       mobile: "",
//       ceo_name: "",
//       description: "",
//       map_link: "",
//       website: "",
//       business_hours: "",
//       category: [],
//       subcategory: [],
//       other_contacts: [{ label: "", number: "" }],
//       social_media: [{ label: "", link: "" }],
//       images: [],
//       products: [{ text: "", image: null }],
//       ceo_image: null,
//       ceo_mobile: "",
//       ceo_mail: "",
//       contact_person_name: "",
//       contact_person_mobile: "",
//       contact_person_mail: "",
//       related_companies: [],
//     });
//     setSelectedCategories([]);
//     setSelectedSubcategories([]);
//     setImagePreviews([]);
//   };

//   const handleEditToggle = () => {
//     if (isEditing && companyData) {
//       initializeFormData(companyData);
//     }
//     setIsEditing(!isEditing);
//   };

//   // Helper function to get category names for display
//   const getCategoryNames = () => {
//     if (!companyData?.category || !categories.length) return "None";

//     return companyData.category
//       .map((catId) => {
//         const category = categories.find((c) => c.category_id === catId);
//         return category ? category.name : null;
//       })
//       .filter(Boolean)
//       .join(", ");
//   };

//   // Helper function to get subcategory names for display
//   const getSubcategoryNames = () => {
//     if (!companyData?.subcategory || !subcategories.length) return "None";

//     return companyData.subcategory
//       .map((subId) => {
//         const subcategory = subcategories.find((s) => s.id === subId);
//         return subcategory ? subcategory.name : null;
//       })
//       .filter(Boolean)
//       .join(", ");
//   };

//   // If user has a company and we're not in edit mode, show the company details
//   if (hasCompany && companyData && !isEditing) {
//     return (
//       <div className="company-container container-fluid mt-4">
//         <div className="company-header row">
//           <div className="col-12">
//             <div className="company-header-content d-flex justify-content-between align-items-center mb-4">
//               <h1 className="company-title h2">Company Details</h1>
//               <div className="company-actions">
//                 <button className="company-btn company-btn-primary me-2">
//                   Preview Public Profile
//                 </button>
//                 <button
//                   className="company-btn company-btn-outline me-2"
//                   onClick={handleEditToggle}
//                 >
//                   Edit Details
//                 </button>
//                 <button
//                   className="company-btn company-btn-danger"
//                   onClick={handleDeleteCompany}
//                 >
//                   Delete Company
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>

//         {message && (
//           <div
//             className={`company-alert alert ${
//               message.includes("Please select") ? "alert-warning" : "alert-info"
//             } alert-dismissible fade show`}
//             role="alert"
//           >
//             {message}
//             <button
//               type="button"
//               className="btn-close"
//               onClick={() => setMessage("")}
//             ></button>
//           </div>
//         )}

//         <div className="company-card card">
//           <div className="company-card-header card-header">
//             <h5 className="company-card-title card-title mb-0">
//               Company Information
//             </h5>
//           </div>
//           <div className="company-card-body card-body">
//             <div className="company-profile row mb-4">
//               <div className="company-logo-section col-md-4 text-center">
//                 {companyData.ceo_image ? (
//                   <img
//                     src={companyData.ceo_image}
//                     className="company-logo img-fluid rounded mb-3"
//                     alt="CEO"
//                     style={{ maxHeight: "150px" }}
//                   />
//                 ) : (
//                   <img
//                     src="https://via.placeholder.com/150"
//                     className="company-logo img-fluid rounded mb-3"
//                     alt="CEO Placeholder"
//                   />
//                 )}
//                 <h5 className="ceo-name">{companyData.ceo_name || "CEO"}</h5>
//                 <p className="ceo-title text-muted">Chief Executive Officer</p>
//               </div>
//               <div className="company-info col-md-8">
//                 <h3 className="company-name">
//                   {companyData.user?.company_name}
//                 </h3>
//                 <p className="company-description text-muted">
//                   {companyData.description || "No description provided"}
//                 </p>

//                 <div className="company-details row mt-4">
//                   <div className="company-contact col-md-6">
//                     <h6 className="company-section-title">
//                       Contact Information
//                     </h6>
//                     <p className="company-contact-info">
//                       <strong>CEO:</strong> {companyData.ceo_name || "N/A"}
//                       <br />
//                       <strong>CEO Email:</strong>{" "}
//                       {companyData.ceo_mail || "N/A"}
//                       <br />
//                       <strong>CEO Mobile:</strong>{" "}
//                       {companyData.ceo_mobile || "N/A"}
//                       <br />
//                       <strong>Company Email:</strong>{" "}
//                       {companyData.user?.email || "N/A"}
//                       <br />
//                       <strong>Company Phone:</strong>{" "}
//                       {companyData.user?.mobile || "N/A"}
//                       <br />
//                       <strong>Contact Person:</strong>{" "}
//                       {companyData.contact_person_name || "N/A"}
//                       <br />
//                       <strong>Contact Person Email:</strong>{" "}
//                       {companyData.contact_person_mail || "N/A"}
//                       <br />
//                       <strong>Contact Person Mobile:</strong>{" "}
//                       {companyData.contact_person_mobile || "N/A"}
//                       <br />
//                       <strong>Address:</strong>{" "}
//                       {companyData.user?.company_address || "N/A"}
//                     </p>
//                   </div>
//                   <div className="company-categories col-md-6">
//                     <h6 className="company-section-title">Website & Hours</h6>
//                     <p className="company-website-hours">
//                       <strong>Website:</strong> {companyData.website || "N/A"}
//                       <br />
//                       <strong>Business Hours:</strong>{" "}
//                       {companyData.business_hours || "N/A"}
//                     </p>

//                     <h6 className="company-section-title mt-3">Categories</h6>
//                     <p className="company-categories-info">
//                       <strong>Main Categories:</strong> {getCategoryNames()}
//                       <br />
//                       <strong>Subcategories:</strong> {getSubcategoryNames()}
//                     </p>

//                     <h6 className="company-section-title mt-3">
//                       Additional Contacts
//                     </h6>
//                     {companyData.other_contacts &&
//                     companyData.other_contacts.length > 0 ? (
//                       companyData.other_contacts.map((contact, index) => (
//                         <p key={index} className="company-additional-contact">
//                           <strong>{contact.label}:</strong> {contact.number}
//                         </p>
//                       ))
//                     ) : (
//                       <p>No additional contacts</p>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="company-extras row">
//               <div className="company-social col-md-6">
//                 <h6 className="company-section-title">Social Media</h6>
//                 {companyData.social_media &&
//                 companyData.social_media.length > 0 ? (
//                   companyData.social_media.map((social, index) => (
//                     <p key={index} className="company-social-item">
//                       <strong>{social.label}:</strong>{" "}
//                       <a
//                         href={social.link}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         {social.link}
//                       </a>
//                     </p>
//                   ))
//                 ) : (
//                   <p>No social media links</p>
//                 )}
//               </div>
//               <div className="company-products col-md-6">
//                 <h6 className="company-section-title">Products/Services</h6>
//                 {companyData.products && companyData.products.length > 0 ? (
//                   companyData.products.map((product, index) => (
//                     <div key={index} className="company-product-item mb-2">
//                       <strong>Product {index + 1}:</strong> {product.text}
//                       {product.image && (
//                         <div className="mt-1">
//                           <small>Image: {product.image}</small>
//                         </div>
//                       )}
//                     </div>
//                   ))
//                 ) : (
//                   <p>No products/services listed</p>
//                 )}
//               </div>
//             </div>

//             {/* Company Images */}
//             {companyData.images && companyData.images.length > 0 && (
//               <div className="company-images mt-4">
//                 <h6 className="company-section-title">Company Images</h6>
//                 <div className="row">
//                   {companyData.images.map((image, index) => (
//                     <div key={index} className="col-md-3 mb-3">
//                       <img
//                         src={image}
//                         alt={`Company ${index + 1}`}
//                         className="img-fluid rounded"
//                       />
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             )}

//             {companyData.map_link && (
//               <div className="company-map mt-4">
//                 <h6 className="company-section-title">Location</h6>
//                 <div className="ratio ratio-16x9">
//                   <iframe
//                     src={companyData.map_link}
//                     style={{ border: 0 }}
//                     allowFullScreen=""
//                     loading="lazy"
//                     referrerPolicy="no-referrer-when-downgrade"
//                     title="Company Location"
//                   ></iframe>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // If user doesn't have a company or is in edit mode, show the form
//   return (
//     <div className="company-container container-fluid mt-4">
//       <div className="company-header row">
//         <div className="col-12">
//           <div className="company-header-content d-flex justify-content-between align-items-center mb-4">
//             <h1 className="company-title h2">
//               {hasCompany ? "Edit Company Details" : "Add Company Details"}
//             </h1>
//             {hasCompany && (
//               <button
//                 className="company-btn company-btn-secondary"
//                 onClick={handleEditToggle}
//               >
//                 Cancel Edit
//               </button>
//             )}
//           </div>
//         </div>
//       </div>

//       {message && (
//         <div
//           className={`company-alert alert ${
//             message.includes("Please select") ? "alert-warning" : "alert-info"
//           } alert-dismissible fade show`}
//           role="alert"
//         >
//           {message}
//           <button
//             type="button"
//             className="btn-close"
//             onClick={() => setMessage("")}
//           ></button>
//         </div>
//       )}

//       <div className="company-form row">
//         <div className="company-sidebar col-md-3">
//           <div className="company-nav-card card">
//             <div className="company-nav-header card-header">
//               <h5 className="company-nav-title card-title mb-0">Navigation</h5>
//             </div>
//             <div className="company-nav-list list-group list-group-flush">
//               <button
//                 className={`company-nav-item list-group-item list-group-item-action ${
//                   activeTab === "basic" ? "active" : ""
//                 }`}
//                 onClick={() => setActiveTab("basic")}
//               >
//                 Basic Information
//               </button>
//               <button
//                 className={`company-nav-item list-group-item list-group-item-action ${
//                   activeTab === "ceo" ? "active" : ""
//                 }`}
//                 onClick={() => setActiveTab("ceo")}
//               >
//                 CEO & Contact Info
//               </button>
//               <button
//                 className={`company-nav-item list-group-item list-group-item-action ${
//                   activeTab === "categories" ? "active" : ""
//                 }`}
//                 onClick={() => setActiveTab("categories")}
//               >
//                 Categories
//               </button>
//               <button
//                 className={`company-nav-item list-group-item list-group-item-action ${
//                   activeTab === "contacts" ? "active" : ""
//                 }`}
//                 onClick={() => setActiveTab("contacts")}
//               >
//                 Additional Contacts
//               </button>
//               <button
//                 className={`company-nav-item list-group-item list-group-item-action ${
//                   activeTab === "social" ? "active" : ""
//                 }`}
//                 onClick={() => setActiveTab("social")}
//               >
//                 Social Media
//               </button>
//               <button
//                 className={`company-nav-item list-group-item list-group-item-action ${
//                   activeTab === "products" ? "active" : ""
//                 }`}
//                 onClick={() => setActiveTab("products")}
//               >
//                 Products
//               </button>
//               <button
//                 className={`company-nav-item list-group-item list-group-item-action ${
//                   activeTab === "images" ? "active" : ""
//                 }`}
//                 onClick={() => setActiveTab("images")}
//               >
//                 Images
//               </button>
//             </div>
//           </div>
//         </div>

//         <div className="company-form-content col-md-9">
//           <div className="company-form-card card">
//             <div className="company-form-header card-header">
//               <h5 className="company-form-title card-title mb-0">
//                 {activeTab === "basic" && "Basic Information"}
//                 {activeTab === "ceo" && "CEO & Contact Person Information"}
//                 {activeTab === "categories" && "Categories & Subcategories"}
//                 {activeTab === "contacts" && "Additional Contacts"}
//                 {activeTab === "social" && "Social Media Links"}
//                 {activeTab === "products" && "Products"}
//                 {activeTab === "images" && "Company Images"}
//               </h5>
//             </div>
//             <div className="company-form-body card-body">
//               <form onSubmit={handleSubmit}>
//                 {/* Basic Information Tab */}
//                 {activeTab === "basic" && (
//                   <div className="company-tab-content">
//                     <div className="company-form-row row mb-3">
//                       <div className="col-md-6">
//                         <label
//                           htmlFor="company_name"
//                           className="company-form-label form-label"
//                         >
//                           Company Name *
//                         </label>
//                         <input
//                           type="text"
//                           className="company-form-input form-control"
//                           id="company_name"
//                           name="company_name"
//                           value={formData.company_name}
//                           onChange={handleChange}
//                           required
//                         />
//                       </div>
//                       <div className="col-md-6">
//                         <label
//                           htmlFor="description"
//                           className="company-form-label form-label"
//                         >
//                           Company Description
//                         </label>
//                         <textarea
//                           className="company-form-textarea form-control"
//                           id="description"
//                           name="description"
//                           rows="2"
//                           value={formData.description}
//                           onChange={handleChange}
//                           placeholder="Describe your company and services..."
//                         ></textarea>
//                       </div>
//                     </div>

//                     <div className="company-form-row row mb-3">
//                       <div className="col-md-6">
//                         <label
//                           htmlFor="email"
//                           className="company-form-label form-label"
//                         >
//                           Company Email *
//                         </label>
//                         <input
//                           type="email"
//                           className="company-form-input form-control"
//                           id="email"
//                           name="email"
//                           value={formData.email}
//                           onChange={handleChange}
//                           required
//                         />
//                       </div>
//                       <div className="col-md-6">
//                         <label
//                           htmlFor="mobile"
//                           className="company-form-label form-label"
//                         >
//                           Company Phone *
//                         </label>
//                         <input
//                           type="text"
//                           className="company-form-input form-control"
//                           id="mobile"
//                           name="mobile"
//                           value={formData.mobile}
//                           onChange={handleChange}
//                           required
//                         />
//                       </div>
//                     </div>

//                     <div className="company-form-field mb-3">
//                       <label
//                         htmlFor="company_address"
//                         className="company-form-label form-label"
//                       >
//                         Company Address *
//                       </label>
//                       <textarea
//                         className="company-form-textarea form-control"
//                         id="company_address"
//                         name="company_address"
//                         rows="2"
//                         value={formData.company_address}
//                         onChange={handleChange}
//                         required
//                       ></textarea>
//                     </div>

//                     <div className="company-form-row row mb-3">
//                       <div className="col-md-6">
//                         <label
//                           htmlFor="website"
//                           className="company-form-label form-label"
//                         >
//                           Website
//                         </label>
//                         <input
//                           type="text"
//                           className="company-form-input form-control"
//                           id="website"
//                           name="website"
//                           value={formData.website}
//                           onChange={handleChange}
//                           placeholder="https://example.com"
//                         />
//                       </div>
//                       <div className="col-md-6">
//                         <label
//                           htmlFor="business_hours"
//                           className="company-form-label form-label"
//                         >
//                           Business Hours
//                         </label>
//                         <input
//                           type="text"
//                           className="company-form-input form-control"
//                           id="business_hours"
//                           name="business_hours"
//                           value={formData.business_hours}
//                           onChange={handleChange}
//                           placeholder="Mon-Fri 9AM-6PM"
//                         />
//                       </div>
//                     </div>

//                     <div className="company-form-field mb-3">
//                       <label
//                         htmlFor="map_link"
//                         className="company-form-label form-label"
//                       >
//                         Google Maps Embed Link
//                       </label>
//                       <input
//                         type="text"
//                         className="company-form-input form-control"
//                         id="map_link"
//                         name="map_link"
//                         value={formData.map_link}
//                         onChange={handleChange}
//                         placeholder="https://maps.google.com/embed?pb=..."
//                       />
//                     </div>
//                   </div>
//                 )}

//                 {/* CEO & Contact Info Tab */}
//                 {activeTab === "ceo" && (
//                   <div className="company-tab-content">
//                     <div className="company-form-row row mb-3">
//                       <div className="col-md-6">
//                         <label
//                           htmlFor="ceo_name"
//                           className="company-form-label form-label"
//                         >
//                           CEO Name
//                         </label>
//                         <input
//                           type="text"
//                           className="company-form-input form-control"
//                           id="ceo_name"
//                           name="ceo_name"
//                           value={formData.ceo_name}
//                           onChange={handleChange}
//                         />
//                       </div>
//                       <div className="col-md-6">
//                         <label
//                           htmlFor="ceo_mobile"
//                           className="company-form-label form-label"
//                         >
//                           CEO Mobile
//                         </label>
//                         <input
//                           type="text"
//                           className="company-form-input form-control"
//                           id="ceo_mobile"
//                           name="ceo_mobile"
//                           value={formData.ceo_mobile}
//                           onChange={handleChange}
//                         />
//                       </div>
//                     </div>

//                     <div className="company-form-row row mb-3">
//                       <div className="col-md-6">
//                         <label
//                           htmlFor="ceo_mail"
//                           className="company-form-label form-label"
//                         >
//                           CEO Email
//                         </label>
//                         <input
//                           type="email"
//                           className="company-form-input form-control"
//                           id="ceo_mail"
//                           name="ceo_mail"
//                           value={formData.ceo_mail}
//                           onChange={handleChange}
//                         />
//                       </div>
//                       <div className="col-md-6">
//                         <label
//                           htmlFor="ceo_image"
//                           className="company-form-label form-label"
//                         >
//                           CEO Photo
//                         </label>
//                         <input
//                           type="file"
//                           className="company-form-input form-control"
//                           id="ceo_image"
//                           accept="image/*"
//                           onChange={(e) => handleImageUpload(e, "ceo_image")}
//                         />
//                       </div>
//                     </div>

//                     <hr />

//                     <div className="company-form-row row mb-3">
//                       <div className="col-md-6">
//                         <label
//                           htmlFor="contact_person_name"
//                           className="company-form-label form-label"
//                         >
//                           Contact Person Name
//                         </label>
//                         <input
//                           type="text"
//                           className="company-form-input form-control"
//                           id="contact_person_name"
//                           name="contact_person_name"
//                           value={formData.contact_person_name}
//                           onChange={handleChange}
//                         />
//                       </div>
//                       <div className="col-md-6">
//                         <label
//                           htmlFor="contact_person_mobile"
//                           className="company-form-label form-label"
//                         >
//                           Contact Person Mobile
//                         </label>
//                         <input
//                           type="text"
//                           className="company-form-input form-control"
//                           id="contact_person_mobile"
//                           name="contact_person_mobile"
//                           value={formData.contact_person_mobile}
//                           onChange={handleChange}
//                         />
//                       </div>
//                     </div>

//                     <div className="company-form-field mb-3">
//                       <label
//                         htmlFor="contact_person_mail"
//                         className="company-form-label form-label"
//                       >
//                         Contact Person Email
//                       </label>
//                       <input
//                         type="email"
//                         className="company-form-input form-control"
//                         id="contact_person_mail"
//                         name="contact_person_mail"
//                         value={formData.contact_person_mail}
//                         onChange={handleChange}
//                       />
//                     </div>
//                   </div>
//                 )}

//                 {/* Categories Tab */}
//                 {activeTab === "categories" && (
//                   <div className="company-tab-content">
//                     <div className="company-alert alert alert-info mb-3">
//                       <i className="bi bi-info-circle"></i> Please select at
//                       least one category. Use Ctrl/Cmd to select multiple
//                       options.
//                     </div>
//                     <div className="company-form-row row mb-3">
//                       <div className="col-md-6">
//                         <label
//                           htmlFor="category"
//                           className="company-form-label form-label"
//                         >
//                           Categories *
//                         </label>
//                         <select
//                           multiple
//                           className="company-form-select form-control"
//                           id="category"
//                           name="category"
//                           value={selectedCategories}
//                           onChange={handleCategoryChange}
//                           required
//                           size="5"
//                         >
//                           {categories.map((cat) => (
//                             <option
//                               key={cat.category_id}
//                               value={cat.category_id}
//                             >
//                               {cat.name}
//                             </option>
//                           ))}
//                         </select>
//                         <small className="company-form-help form-text text-muted">
//                           Hold Ctrl/Cmd to select multiple categories
//                         </small>
//                       </div>
//                       <div className="col-md-6">
//                         <label
//                           htmlFor="subcategory"
//                           className="company-form-label form-label"
//                         >
//                           Subcategories
//                         </label>
//                         <select
//                           multiple
//                           className="company-form-select form-control"
//                           id="subcategory"
//                           name="subcategory"
//                           value={selectedSubcategories}
//                           onChange={handleSubcategoryChange}
//                           size="5"
//                         >
//                           {subcategories.map((sub) => (
//                             <option key={sub.id} value={sub.id}>
//                               {sub.name}
//                             </option>
//                           ))}
//                         </select>
//                         <small className="company-form-help form-text text-muted">
//                           Hold Ctrl/Cmd to select multiple subcategories
//                         </small>
//                       </div>
//                     </div>
//                     <div className="company-alert alert alert-info">
//                       <i className="bi bi-info-circle"></i> Selected Categories:{" "}
//                       {selectedCategories
//                         .map((id) => {
//                           const cat = categories.find(
//                             (c) => c.category_id === id,
//                           );
//                           return cat ? cat.name : null;
//                         })
//                         .filter(Boolean)
//                         .join(", ") || "None"}
//                     </div>
//                     <div className="company-alert alert alert-info">
//                       <i className="bi bi-info-circle"></i> Selected
//                       Subcategories:{" "}
//                       {selectedSubcategories
//                         .map((id) => {
//                           const sub = subcategories.find((s) => s.id === id);
//                           return sub ? sub.name : null;
//                         })
//                         .filter(Boolean)
//                         .join(", ") || "None"}
//                     </div>
//                   </div>
//                 )}

//                 {/* Additional Contacts Tab */}
//                 {activeTab === "contacts" && (
//                   <div className="company-tab-content">
//                     <div className="company-form-field mb-3">
//                       <label className="company-form-label form-label">
//                         Additional Contact Numbers
//                       </label>
//                       {formData.other_contacts.map((contact, index) => (
//                         <div
//                           key={index}
//                           className="company-contact-field row mb-2"
//                         >
//                           <div className="col-md-5">
//                             <input
//                               type="text"
//                               className="company-form-input form-control"
//                               placeholder="Label (e.g., Manager, Support)"
//                               value={contact.label}
//                               onChange={(e) =>
//                                 handleContactChange(
//                                   index,
//                                   "label",
//                                   e.target.value,
//                                 )
//                               }
//                             />
//                           </div>
//                           <div className="col-md-5">
//                             <input
//                               type="text"
//                               className="company-form-input form-control"
//                               placeholder="Phone number"
//                               value={contact.number}
//                               onChange={(e) =>
//                                 handleContactChange(
//                                   index,
//                                   "number",
//                                   e.target.value,
//                                 )
//                               }
//                             />
//                           </div>
//                           <div className="col-md-2">
//                             <button
//                               type="button"
//                               className="company-btn company-btn-danger w-100"
//                               onClick={() => removeContactField(index)}
//                               disabled={formData.other_contacts.length <= 1}
//                             >
//                               Remove
//                             </button>
//                           </div>
//                         </div>
//                       ))}
//                       <button
//                         type="button"
//                         className="company-btn company-btn-outline mt-2"
//                         onClick={addContactField}
//                       >
//                         + Add Another Contact
//                       </button>
//                     </div>
//                   </div>
//                 )}

//                 {/* Social Media Tab */}
//                 {activeTab === "social" && (
//                   <div className="company-tab-content">
//                     <div className="company-form-field mb-3">
//                       <label className="company-form-label form-label">
//                         Social Media Links
//                       </label>
//                       {formData.social_media.map((social, index) => (
//                         <div
//                           key={index}
//                           className="company-social-field row mb-2"
//                         >
//                           <div className="col-md-5">
//                             <select
//                               className="company-form-select form-control"
//                               value={social.label}
//                               onChange={(e) =>
//                                 handleSocialMediaChange(
//                                   index,
//                                   "label",
//                                   e.target.value,
//                                 )
//                               }
//                             >
//                               <option value="">Select Platform</option>
//                               <option value="Facebook">Facebook</option>
//                               <option value="LinkedIn">LinkedIn</option>
//                               <option value="Twitter">Twitter</option>
//                               <option value="Instagram">Instagram</option>
//                               <option value="YouTube">YouTube</option>
//                               <option value="WhatsApp">WhatsApp</option>
//                               <option value="Telegram">Telegram</option>
//                               <option value="Other">Other</option>
//                             </select>
//                           </div>
//                           <div className="col-md-5">
//                             <input
//                               type="text"
//                               className="company-form-input form-control"
//                               placeholder="Profile URL"
//                               value={social.link}
//                               onChange={(e) =>
//                                 handleSocialMediaChange(
//                                   index,
//                                   "link",
//                                   e.target.value,
//                                 )
//                               }
//                             />
//                           </div>
//                           <div className="col-md-2">
//                             <button
//                               type="button"
//                               className="company-btn company-btn-danger w-100"
//                               onClick={() => removeSocialMediaField(index)}
//                               disabled={formData.social_media.length <= 1}
//                             >
//                               Remove
//                             </button>
//                           </div>
//                         </div>
//                       ))}
//                       <button
//                         type="button"
//                         className="company-btn company-btn-outline mt-2"
//                         onClick={addSocialMediaField}
//                       >
//                         + Add Another Social Media
//                       </button>
//                     </div>
//                   </div>
//                 )}

//                 {/* Products Tab */}
//                 {activeTab === "products" && (
//                   <div className="company-tab-content">
//                     <div className="company-form-field mb-3">
//                       <label className="company-form-label form-label">
//                         Products/Services
//                       </label>
//                       {formData.products.map((product, index) => (
//                         <div
//                           key={index}
//                           className="company-product-card card mb-3"
//                         >
//                           <div className="company-product-body card-body">
//                             <div className="company-product-row row mb-2">
//                               <div className="col-md-10">
//                                 <label className="company-form-label form-label">
//                                   Product Description
//                                 </label>
//                                 <textarea
//                                   className="company-form-textarea form-control"
//                                   rows="2"
//                                   placeholder="Describe your product or service..."
//                                   value={product.text}
//                                   onChange={(e) =>
//                                     handleProductChange(
//                                       index,
//                                       "text",
//                                       e.target.value,
//                                     )
//                                   }
//                                 ></textarea>
//                               </div>
//                               <div className="col-md-2 d-flex align-items-end">
//                                 <button
//                                   type="button"
//                                   className="company-btn company-btn-danger w-100"
//                                   onClick={() => removeProductField(index)}
//                                   disabled={formData.products.length <= 1}
//                                 >
//                                   Remove
//                                 </button>
//                               </div>
//                             </div>
//                             <div className="company-product-row row">
//                               <div className="col-md-12">
//                                 <label className="company-form-label form-label">
//                                   Product Image
//                                 </label>
//                                 <input
//                                   type="file"
//                                   className="company-form-input form-control"
//                                   accept="image/*"
//                                   onChange={(e) =>
//                                     handleProductChange(
//                                       index,
//                                       "image",
//                                       e.target.files[0],
//                                     )
//                                   }
//                                 />
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       ))}
//                       <button
//                         type="button"
//                         className="company-btn company-btn-outline mt-2"
//                         onClick={addProductField}
//                       >
//                         + Add Another Product
//                       </button>
//                     </div>
//                   </div>
//                 )}

//                 {/* Images Tab */}
//                 {activeTab === "images" && (
//                   <div className="company-tab-content">
//                     <div className="company-form-field mb-3">
//                       <label className="company-form-label form-label">
//                         Company Images
//                       </label>
//                       <div className="company-images-upload mb-3">
//                         <input
//                           type="file"
//                           className="company-form-input form-control"
//                           accept="image/*"
//                           multiple
//                           onChange={(e) => handleImageUpload(e, "images")}
//                         />
//                         <small className="form-text text-muted">
//                           Upload multiple images of your company
//                         </small>
//                       </div>

//                       {imagePreviews.length > 0 && (
//                         <div className="company-images-preview mt-3">
//                           <h6 className="company-section-title">
//                             Image Previews
//                           </h6>
//                           <div className="row">
//                             {imagePreviews.map((preview, index) => (
//                               <div key={index} className="col-md-3 mb-3">
//                                 <div className="image-preview-container position-relative">
//                                   <img
//                                     src={preview}
//                                     alt={`Preview ${index + 1}`}
//                                     className="img-fluid rounded"
//                                   />
//                                   <button
//                                     type="button"
//                                     className="btn-close position-absolute top-0 end-0 m-1 bg-white rounded-circle p-1"
//                                     onClick={() => removeImage(index)}
//                                   ></button>
//                                 </div>
//                               </div>
//                             ))}
//                           </div>
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 )}

//                 <div className="company-form-actions d-flex justify-content-between mt-4">
//                   <div>
//                     {activeTab !== "basic" && (
//                       <button
//                         type="button"
//                         className="company-btn company-btn-secondary me-2"
//                         onClick={() => {
//                           const tabs = [
//                             "basic",
//                             "ceo",
//                             "categories",
//                             "contacts",
//                             "social",
//                             "products",
//                             "images",
//                           ];
//                           const currentIndex = tabs.indexOf(activeTab);
//                           if (currentIndex > 0)
//                             setActiveTab(tabs[currentIndex - 1]);
//                         }}
//                       >
//                         Previous
//                       </button>
//                     )}
//                     {activeTab !== "images" && (
//                       <button
//                         type="button"
//                         className="company-btn company-btn-primary"
//                         onClick={() => {
//                           const tabs = [
//                             "basic",
//                             "ceo",
//                             "categories",
//                             "contacts",
//                             "social",
//                             "products",
//                             "images",
//                           ];
//                           const currentIndex = tabs.indexOf(activeTab);
//                           if (currentIndex < tabs.length - 1)
//                             setActiveTab(tabs[currentIndex + 1]);
//                         }}
//                       >
//                         Next
//                       </button>
//                     )}
//                   </div>
//                   <button
//                     type="submit"
//                     className="company-btn company-btn-success"
//                     disabled={loading}
//                   >
//                     {loading
//                       ? "Saving..."
//                       : hasCompany
//                         ? "Update Company"
//                         : "Add Company"}
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CompanyDetails;


import React, { useState, useEffect } from "react";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Companydetails.css";

const CompanyDetails = ({ user }) => {
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [companyData, setCompanyData] = useState(null);
  const [formData, setFormData] = useState({
    company_name: "",
    company_address: "",
    email: "",
    mobile: "",
    ceo_name: "",
    description: "",
    map_link: "",
    website: "",
    business_hours: "",
    category: [],
    subcategory: [],
    other_contacts: [{ label: "", number: "" }],
    social_media: [{ label: "", link: "" }],
    images: [],
    products: [{ text: "", image: null }],
    ceo_image: null,
    ceo_mobile: "",
    ceo_mail: "",
    contact_person_name: "",
    contact_person_mobile: "",
    contact_person_mail: "",
    related_companies: [],
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [activeTab, setActiveTab] = useState("basic");
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedSubcategories, setSelectedSubcategories] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [hasCompany, setHasCompany] = useState(false);
  
  const [imageFiles, setImageFiles] = useState({
    ceo_image: null,
    company_images: [],
    product_images: []
  });
  
  const [imagePreviews, setImagePreviews] = useState({
    ceo_image: null,
    company_images: [],
    product_images: []
  });

  // Track which product images are new uploads vs existing
  const [existingProductImages, setExistingProductImages] = useState([]);

  useEffect(() => {
    fetchCategories();
    fetchSubcategories();
    fetchCompanyData();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await fetch(
        "https://ambatturindustrialestate.com/api/api/categories/",
      );
      const data = await response.json();
      setCategories(data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const fetchSubcategories = async () => {
    try {
      const response = await fetch(
        "https://ambatturindustrialestate.com/api/api/subcategories/",
      );
      const data = await response.json();
      setSubcategories(data);
    } catch (error) {
      console.error("Error fetching subcategories:", error);
    }
  };

  const fetchCompanyData = async () => {
    try {
      const token = localStorage.getItem("access");
      console.log("Fetching company data with token:", token ? "Token exists" : "No token");
      
      const response = await fetch(
        "https://ambatturindustrialestate.com/api/api/my-company/",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      console.log("API Response status:", response.status);
      
      if (response.ok) {
        const data = await response.json();
        console.log("Fetched company data - FULL RESPONSE:", data);
        
        if (data.detail && data.detail === "Company not found for this user.") {
          console.log("Company not found for user");
          setHasCompany(false);
          setCompanyData(null);
        } else if (data.id) {
          console.log("Company found, setting data...");
          setHasCompany(true);
          setCompanyData(data);
          initializeFormData(data);
        } else {
          console.error("Unexpected API response format:", data);
          setHasCompany(false);
          setCompanyData(null);
        }
      } else {
        const errorData = await response.json();
        console.error("Failed to fetch company data - Error:", errorData);
        if (errorData.detail === "Company not found for this user.") {
          setHasCompany(false);
          setCompanyData(null);
        } else {
          console.error("Failed to fetch company data:", errorData);
          setHasCompany(false);
          setCompanyData(null);
        }
      }
    } catch (error) {
      console.error("Error fetching company data:", error);
      setHasCompany(false);
      setCompanyData(null);
    }
  };

  const getImageUrl = (image) => {
    if (!image) return "https://via.placeholder.com/150";
    
    if (typeof image === "string") {
      if (image.startsWith('http') || image.startsWith('data:')) {
        return image;
      }
      return `https://ambatturindustrialestate.com/api/media/${image}`;
    }
    
    if (typeof image === "object") {
      if (image.image) {
        if (image.image.startsWith('http') || image.image.startsWith('data:')) {
          return image.image;
        }
        return `https://ambatturindustrialestate.com/api/media/${image.image}`;
      }
      if (image.url) {
        if (image.url.startsWith('http') || image.url.startsWith('data:')) {
          return image.url;
        }
        return `https://ambatturindustrialestate.com/api/media/${image.url}`;
      }
    }
    
    return "https://via.placeholder.com/150";
  };

  const initializeFormData = (data) => {
    console.log("========== INITIALIZE FORM DATA ==========");
    console.log("Full data received:", data);
    
    // Extract all possible data sources
    const userData = data.user || {};
    const companyInfo = data;
    
    // Try multiple sources for each field
    const companyName = userData.company_name || companyInfo.company_name || data.name || "";
    const email = userData.email || companyInfo.email || "";
    const mobile = userData.mobile || companyInfo.mobile || "";
    const companyAddress = companyInfo.company_address || userData.company_address || "";
    
    // Format category and subcategory
    const formattedCategory = Array.isArray(data.category) 
      ? data.category.map(item => {
          if (typeof item === 'object' && item.category_id) {
            return item.category_id;
          }
          return typeof item === 'number' ? item : parseInt(item);
        }).filter(id => !isNaN(id))
      : [];
    
    const formattedSubcategory = Array.isArray(data.subcategory) 
      ? data.subcategory.map(item => {
          if (typeof item === 'object' && item.id) {
            return item.id;
          }
          return typeof item === 'number' ? item : parseInt(item);
        }).filter(id => !isNaN(id))
      : [];
    
    // Format other_contacts
    let formattedContacts = [{ label: "", number: "" }];
    if (data.other_contacts && Array.isArray(data.other_contacts) && data.other_contacts.length > 0) {
      formattedContacts = data.other_contacts.map((contact) => ({
        label: contact.label || "",
        number: contact.number || "",
      }));
    }

    // Format social_media
    let formattedSocialMedia = [{ label: "", link: "" }];
    if (data.social_media && Array.isArray(data.social_media) && data.social_media.length > 0) {
      formattedSocialMedia = data.social_media.map((social) => ({
        label: social.label || "",
        link: social.link || "",
      }));
    }

    // Format products - IMPORTANT: Keep original image data
    let formattedProducts = [{ text: "", image: null }];
    let existingImages = [];
    
    if (data.products && Array.isArray(data.products) && data.products.length > 0) {
      formattedProducts = data.products.map((product, index) => {
        // Store existing image data
        if (product.image) {
          existingImages[index] = product.image;
        }
        return {
          text: product.text || "",
          image: product.image || null,
        };
      });
    }

    // Store existing product images
    setExistingProductImages(existingImages);

    // Set image previews
    const ceoImagePreview = data.ceo_image 
      ? getImageUrl(data.ceo_image)
      : null;
    
    let companyImagePreviews = [];
    if (data.images && Array.isArray(data.images)) {
      companyImagePreviews = data.images.map((img) => {
        return getImageUrl(img);
      }).filter(img => img !== null);
    }

    const productImagePreviews = formattedProducts.map((product, index) => 
      product.image ? getImageUrl(product.image) : null
    );

    console.log("Setting image previews...");
    
    setImagePreviews({
      ceo_image: ceoImagePreview,
      company_images: companyImagePreviews,
      product_images: productImagePreviews
    });

    setImageFiles({
      ceo_image: null,
      company_images: new Array(companyImagePreviews.length).fill(null),
      product_images: new Array(productImagePreviews.length).fill(null)
    });

    // Create the form data object
    const newFormData = {
      company_name: companyName,
      company_address: companyAddress,
      email: email,
      mobile: mobile,
      ceo_name: data.ceo_name || "",
      description: data.description || "",
      map_link: data.map_link || "",
      website: data.website || "",
      business_hours: data.business_hours || "",
      category: formattedCategory,
      subcategory: formattedSubcategory,
      other_contacts: formattedContacts,
      social_media: formattedSocialMedia,
      images: data.images || [],
      products: formattedProducts,
      ceo_image: data.ceo_image || null,
      ceo_mobile: data.ceo_mobile || "",
      ceo_mail: data.ceo_mail || "",
      contact_person_name: data.contact_person_name || "",
      contact_person_mobile: data.contact_person_mobile || "",
      contact_person_mail: data.contact_person_mail || "",
      related_companies: data.related_companies || [],
    };

    console.log("Final form data to set:", newFormData);
    
    setFormData(newFormData);
    setSelectedCategories(formattedCategory);
    setSelectedSubcategories(formattedSubcategory);
    
    console.log("========== FORM DATA INITIALIZED ==========");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(`Form field changed: ${name} = ${value}`);
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleCategoryChange = (e) => {
    const options = e.target.options;
    const newSelectedCategories = [];
    for (let i = 0; i < options.length; i++) {
      if (options[i].selected) {
        newSelectedCategories.push(parseInt(options[i].value));
      }
    }
    setSelectedCategories(newSelectedCategories);
    setFormData({
      ...formData,
      category: newSelectedCategories,
    });
  };

  const handleSubcategoryChange = (e) => {
    const options = e.target.options;
    const newSelectedSubcategories = [];
    for (let i = 0; i < options.length; i++) {
      if (options[i].selected) {
        newSelectedSubcategories.push(parseInt(options[i].value));
      }
    }
    setSelectedSubcategories(newSelectedSubcategories);
    setFormData({
      ...formData,
      subcategory: newSelectedSubcategories,
    });
  };

  const handleContactChange = (index, field, value) => {
    const updatedContacts = [...formData.other_contacts];
    updatedContacts[index][field] = value;

    setFormData({
      ...formData,
      other_contacts: updatedContacts,
    });
  };

  const addContactField = () => {
    setFormData({
      ...formData,
      other_contacts: [...formData.other_contacts, { label: "", number: "" }],
    });
  };

  const removeContactField = (index) => {
    if (formData.other_contacts.length > 1) {
      const updatedContacts = [...formData.other_contacts];
      updatedContacts.splice(index, 1);

      setFormData({
        ...formData,
        other_contacts: updatedContacts,
      });
    }
  };

  const handleSocialMediaChange = (index, field, value) => {
    const updatedSocialMedia = [...formData.social_media];
    updatedSocialMedia[index][field] = value;

    setFormData({
      ...formData,
      social_media: updatedSocialMedia,
    });
  };

  const addSocialMediaField = () => {
    setFormData({
      ...formData,
      social_media: [...formData.social_media, { label: "", link: "" }],
    });
  };

  const removeSocialMediaField = (index) => {
    if (formData.social_media.length > 1) {
      const updatedSocialMedia = [...formData.social_media];
      updatedSocialMedia.splice(index, 1);

      setFormData({
        ...formData,
        social_media: updatedSocialMedia,
      });
    }
  };

  const handleProductChange = (index, field, value) => {
    const updatedProducts = [...formData.products];
    updatedProducts[index][field] = value;

    setFormData({
      ...formData,
      products: updatedProducts,
    });
  };

  const handleProductImageUpload = (e, index) => {
    const file = e.target.files[0];
    if (file) {
      const newProductImages = [...imageFiles.product_images];
      newProductImages[index] = file;
      setImageFiles({
        ...imageFiles,
        product_images: newProductImages
      });

      const reader = new FileReader();
      reader.onload = (e) => {
        const newPreviews = [...imagePreviews.product_images];
        newPreviews[index] = e.target.result;
        setImagePreviews({
          ...imagePreviews,
          product_images: newPreviews
        });
      };
      reader.readAsDataURL(file);

      const updatedProducts = [...formData.products];
      updatedProducts[index] = {
        ...updatedProducts[index],
        image: file.name // Store new file name
      };
      setFormData({
        ...formData,
        products: updatedProducts,
      });
    }
  };

  const addProductField = () => {
    setFormData({
      ...formData,
      products: [...formData.products, { text: "", image: null }],
    });
    
    setImageFiles({
      ...imageFiles,
      product_images: [...imageFiles.product_images, null]
    });
    
    setImagePreviews({
      ...imagePreviews,
      product_images: [...imagePreviews.product_images, null]
    });
    
    // Add empty slot for new product image
    const newExistingImages = [...existingProductImages];
    newExistingImages[formData.products.length] = null;
    setExistingProductImages(newExistingImages);
  };

  const removeProductField = (index) => {
    if (formData.products.length > 1) {
      const updatedProducts = [...formData.products];
      updatedProducts.splice(index, 1);

      const updatedImageFiles = [...imageFiles.product_images];
      updatedImageFiles.splice(index, 1);
      
      const updatedPreviews = [...imagePreviews.product_images];
      updatedPreviews.splice(index, 1);
      
      const updatedExistingImages = [...existingProductImages];
      updatedExistingImages.splice(index, 1);

      setFormData({
        ...formData,
        products: updatedProducts,
      });
      
      setImageFiles({
        ...imageFiles,
        product_images: updatedImageFiles
      });
      
      setImagePreviews({
        ...imagePreviews,
        product_images: updatedPreviews
      });
      
      setExistingProductImages(updatedExistingImages);
    }
  };

  const handleImageUpload = async (e, field) => {
    const files = e.target.files;
    if (files.length > 0) {
      if (field === "images") {
        const newFiles = Array.from(files);
        const newPreviews = [];

        newFiles.forEach((file) => {
          const reader = new FileReader();
          reader.onload = (e) => {
            newPreviews.push(e.target.result);
            if (newPreviews.length === newFiles.length) {
              setImagePreviews({
                ...imagePreviews,
                company_images: [...imagePreviews.company_images, ...newPreviews]
              });
              
              setImageFiles({
                ...imageFiles,
                company_images: [...imageFiles.company_images, ...newFiles]
              });
              
              setFormData({
                ...formData,
                images: [...formData.images, ...newFiles.map(file => ({ image: file.name }))]
              });
            }
          };
          reader.readAsDataURL(file);
        });
      } else if (field === "ceo_image") {
        const file = files[0];
        const reader = new FileReader();
        
        reader.onload = (e) => {
          setImagePreviews({
            ...imagePreviews,
            ceo_image: e.target.result
          });
        };
        reader.readAsDataURL(file);
        
        setImageFiles({
          ...imageFiles,
          ceo_image: file
        });
        
        setFormData({
          ...formData,
          ceo_image: file.name
        });
      }
    }
  };

  const removeImage = (index) => {
    const updatedImages = [...formData.images];
    updatedImages.splice(index, 1);

    const updatedPreviews = [...imagePreviews.company_images];
    updatedPreviews.splice(index, 1);
    
    const updatedFiles = [...imageFiles.company_images];
    updatedFiles.splice(index, 1);

    setImagePreviews({
      ...imagePreviews,
      company_images: updatedPreviews
    });
    
    setImageFiles({
      ...imageFiles,
      company_images: updatedFiles
    });
    
    setFormData({
      ...formData,
      images: updatedImages,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Form submitted");

    if (selectedCategories.length === 0) {
      setMessage("Please select at least one category.");
      setActiveTab("categories");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      const token = localStorage.getItem("access");
      const url = hasCompany && companyData
        ? `https://ambatturindustrialestate.com/api/api/company/${companyData.id}/update/`
        : "https://ambatturindustrialestate.com/api/api/companies/add/";

      const method = hasCompany && companyData ? "PUT" : "POST";

      // Prepare products data - use existing images if no new upload
      const preparedProducts = formData.products.map((product, index) => {
        // If there's a new file upload, use it
        if (imageFiles.product_images[index] instanceof File) {
          return {
            text: product.text,
            image: product.image || null
          };
        }
        // Otherwise, check if there's an existing image
        else if (existingProductImages[index]) {
          return {
            text: product.text,
            image: existingProductImages[index]
          };
        }
        // No image at all
        else {
          return {
            text: product.text,
            image: null
          };
        }
      }).filter(product => product.text || product.image);

      const requestData = {
        category: selectedCategories,
        subcategory: selectedSubcategories,
        ceo_name: formData.ceo_name,
        ceo_mobile: formData.ceo_mobile,
        ceo_mail: formData.ceo_mail,
        contact_person_name: formData.contact_person_name,
        contact_person_mobile: formData.contact_person_mobile,
        contact_person_mail: formData.contact_person_mail,
        company_address: formData.company_address,
        description: formData.description,
        map_link: formData.map_link,
        website: formData.website,
        business_hours: formData.business_hours,
        other_contacts: formData.other_contacts.filter(
          (contact) => contact.label && contact.number
        ),
        social_media: formData.social_media.filter(
          (social) => social.label && social.link
        ),
        products: preparedProducts
      };

      console.log("Request data:", requestData);
      console.log("Existing product images:", existingProductImages);
      console.log("Image files:", imageFiles.product_images);

      const formDataToSend = new FormData();
      
      for (const key in requestData) {
        if (key === 'category' || key === 'subcategory') {
          requestData[key].forEach(value => {
            formDataToSend.append(key, value.toString());
          });
        } else if (key === 'other_contacts' || key === 'social_media' || key === 'products') {
          if (requestData[key].length > 0) {
            formDataToSend.append(key, JSON.stringify(requestData[key]));
          }
        } else {
          if (requestData[key] !== undefined && requestData[key] !== null) {
            formDataToSend.append(key, requestData[key]);
          }
        }
      }

      if (imageFiles.ceo_image) {
        formDataToSend.append("ceo_image", imageFiles.ceo_image);
      }

      // Add product images - only add if there's a new file
      imageFiles.product_images.forEach((file, index) => {
        if (file instanceof File) {
          formDataToSend.append(`product_image_${index}`, file);
        }
      });

      // Add company images
      imageFiles.company_images.forEach((file, index) => {
        if (file instanceof File) {
          formDataToSend.append(`images`, file);
        }
      });

      console.log("FormData entries:");
      for (let pair of formDataToSend.entries()) {
        console.log(pair[0] + ': ' + (pair[1] instanceof File ? pair[1].name : pair[1]));
      }

      const response = await fetch(url, {
        method: method,
        headers: {
          "Authorization": `Bearer ${token}`,
        },
        body: formDataToSend,
      });

      if (response.ok) {
        const result = await response.json();
        console.log("API Response:", result);
        const successMessage = hasCompany
          ? "Company details updated successfully!"
          : "Company details added successfully!";
        setMessage(successMessage);
        
        setTimeout(() => {
          fetchCompanyData();
        }, 1000);
        setIsEditing(false);
      } else {
        const errorData = await response.json();
        console.error("API Error:", errorData);
        
        if (errorData.detail) {
          setMessage(`Error: ${errorData.detail}`);
        } else if (errorData.message) {
          setMessage(`Error: ${errorData.message}`);
        } else if (errorData.description) {
          setMessage(`Error: ${Array.isArray(errorData.description) ? errorData.description.join(', ') : errorData.description}`);
        } else {
          setMessage("Failed to update company details. Please try again.");
        }
      }
    } catch (error) {
      console.error("Error updating company:", error);
      setMessage("An error occurred. Please try again.");
    }

    setLoading(false);
  };

  const handleDeleteCompany = async () => {
    if (
      window.confirm(
        "Are you sure you want to delete your company details? This action cannot be undone.",
      )
    ) {
      try {
        const token = localStorage.getItem("access");
        const response = await fetch(
          `https://ambatturindustrialestate.com/api/api/companies-update&delete/${companyData.id}/`,
          {
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (response.ok) {
          setMessage("Company details deleted successfully!");
          setHasCompany(false);
          setCompanyData(null);
          resetFormData();
        } else {
          setMessage("Failed to delete company details. Please try again.");
        }
      } catch (error) {
        console.error("Error deleting company:", error);
        setMessage("An error occurred. Please try again.");
      }
    }
  };

  const resetFormData = () => {
    setFormData({
      company_name: "",
      company_address: "",
      email: "",
      mobile: "",
      ceo_name: "",
      description: "",
      map_link: "",
      website: "",
      business_hours: "",
      category: [],
      subcategory: [],
      other_contacts: [{ label: "", number: "" }],
      social_media: [{ label: "", link: "" }],
      images: [],
      products: [{ text: "", image: null }],
      ceo_image: null,
      ceo_mobile: "",
      ceo_mail: "",
      contact_person_name: "",
      contact_person_mobile: "",
      contact_person_mail: "",
      related_companies: [],
    });
    setSelectedCategories([]);
    setSelectedSubcategories([]);
    setImagePreviews({
      ceo_image: null,
      company_images: [],
      product_images: []
    });
    setImageFiles({
      ceo_image: null,
      company_images: [],
      product_images: []
    });
    setExistingProductImages([]);
  };

  const handleEditToggle = () => {
    console.log("Edit toggle clicked. Current isEditing:", isEditing);
    console.log("Current companyData:", companyData);
    
    if (isEditing && companyData) {
      console.log("Initializing form with existing company data");
      initializeFormData(companyData);
    } else {
      console.log("Entering edit mode");
    }
    setIsEditing(!isEditing);
  };

  const getCategoryNames = () => {
    if (!companyData?.category || !categories.length) return "None";

    const categoryIds = companyData.category.map(item => 
      typeof item === 'object' ? item.category_id : item
    );
    
    return categoryIds
      .map((catId) => {
        const category = categories.find((c) => c.category_id === catId);
        return category ? category.name : null;
      })
      .filter(Boolean)
      .join(", ");
  };

  const getSubcategoryNames = () => {
    if (!companyData?.subcategory || !subcategories.length) return "None";

    const subcategoryIds = companyData.subcategory.map(item => 
      typeof item === 'object' ? item.id : item
    );
    
    return subcategoryIds
      .map((subId) => {
        const subcategory = subcategories.find((s) => s.id === subId);
        return subcategory ? subcategory.name : null;
      })
      .filter(Boolean)
      .join(", ");
  };
const getEmbedUrl = (mapLink) => {
  if (!mapLink) return "";
  
  // If it's already an embed URL, return as is
  if (mapLink.includes("embed")) {
    return mapLink;
  }
  
  // If it's a Google Maps short link, don't try to embed it
  // Return null to show a button instead
  return null;
};
  // Helper function to get display values
  const getDisplayCompanyName = () => {
    if (!companyData) return "N/A";
    return companyData.user?.company_name || companyData.company_name || companyData.name || "N/A";
  };

  const getDisplayEmail = () => {
    if (!companyData) return "N/A";
    return companyData.user?.email || companyData.email || "N/A";
  };

  const getDisplayMobile = () => {
    if (!companyData) return "N/A";
    return companyData.user?.mobile || companyData.mobile || "N/A";
  };

  if (hasCompany && companyData && !isEditing) {
    return (
      <div className="company-container container-fluid mt-4">
        <div className="company-header row">
          <div className="col-12">
            <div className="company-header-content d-flex justify-content-between align-items-center mb-4">
              <h1 className="company-title h2">Company Details</h1>
              <div className="company-actions">
                <button className="company-btn company-btn-primary me-2">
                  Preview Public Profile
                </button>
                <button
                  className="company-btn company-btn-outline me-2"
                  onClick={handleEditToggle}
                >
                  Edit Details
                </button>
                <button
                  className="company-btn company-btn-danger"
                  onClick={handleDeleteCompany}
                >
                  Delete Company
                </button>
              </div>
            </div>
          </div>
        </div>

        {message && (
          <div
            className={`company-alert alert ${
              message.includes("Please select") ? "alert-warning" : "alert-info"
            } alert-dismissible fade show`}
            role="alert"
          >
            {message}
            <button
              type="button"
              className="btn-close"
              onClick={() => setMessage("")}
            ></button>
          </div>
        )}

        <div className="company-card card">
          <div className="company-card-header card-header">
            <h5 className="company-card-title card-title mb-0">
              Company Information
            </h5>
          </div>
          <div className="company-card-body card-body">
            <div className="company-profile row mb-4">
              <div className="company-logo-section col-md-4 text-center">
                {companyData.ceo_image ? (
                  <img
                    src={getImageUrl(companyData.ceo_image)}
                    className="company-logo img-fluid rounded mb-3"
                    alt="CEO"
                    style={{ maxHeight: "150px" }}
                  />
                ) : (
                  <img
                    src="https://via.placeholder.com/150"
                    className="company-logo img-fluid rounded mb-3"
                    alt="CEO Placeholder"
                  />
                )}
                <h5 className="ceo-name">{companyData.ceo_name || "CEO"}</h5>
                <p className="ceo-title text-muted">Chief Executive Officer</p>
              </div>
              <div className="company-info col-md-8">
                <h3 className="company-name">
                  {getDisplayCompanyName()}
                </h3>
                <p className="company-description text-muted">
                  {companyData.description || "No description provided"}
                </p>

                <div className="company-details row mt-4">
                  <div className="company-contact col-md-6">
                    <h6 className="company-section-title">
                      Contact Information
                    </h6>
                    <p className="company-contact-info">
                      <strong>CEO:</strong> {companyData.ceo_name || "N/A"}
                      <br />
                      <strong>CEO Email:</strong>{" "}
                      {companyData.ceo_mail || "N/A"}
                      <br />
                      <strong>CEO Mobile:</strong>{" "}
                      {companyData.ceo_mobile || "N/A"}
                      <br />
                      <strong>Company Email:</strong>{" "}
                      {getDisplayEmail()}
                      <br />
                      <strong>Company Phone:</strong>{" "}
                      {getDisplayMobile()}
                      <br />
                      <strong>Contact Person:</strong>{" "}
                      {companyData.contact_person_name || "N/A"}
                      <br />
                      <strong>Contact Person Email:</strong>{" "}
                      {companyData.contact_person_mail || "N/A"}
                      <br />
                      <strong>Contact Person Mobile:</strong>{" "}
                      {companyData.contact_person_mobile || "N/A"}
                      <br />
                      <strong>Address:</strong>{" "}
                      {companyData.company_address ||
                        companyData.user?.company_address ||
                        "N/A"}
                    </p>
                  </div>
                  <div className="company-categories col-md-6">
                    <h6 className="company-section-title">Website & Hours</h6>
                    <p className="company-website-hours">
                      <strong>Website:</strong> {companyData.website || "N/A"}
                      <br />
                      <strong>Business Hours:</strong>{" "}
                      {companyData.business_hours || "N/A"}
                    </p>

                    <h6 className="company-section-title mt-3">Categories</h6>
                    <p className="company-categories-info">
                      <strong>Main Categories:</strong> {getCategoryNames()}
                      <br />
                      <strong>Subcategories:</strong> {getSubcategoryNames()}
                    </p>

                    <h6 className="company-section-title mt-3">
                      Additional Contacts
                    </h6>
                    {companyData.other_contacts && 
                     Array.isArray(companyData.other_contacts) && 
                     companyData.other_contacts.length > 0 ? (
                      companyData.other_contacts.map((contact, index) => (
                        <p key={index} className="company-additional-contact">
                          <strong>{contact.label || "Contact"}:</strong> {contact.number || "N/A"}
                        </p>
                      ))
                    ) : (
                      <p>No additional contacts</p>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="company-extras row">
              <div className="company-social col-md-6">
                <h6 className="company-section-title">Social Media</h6>
                {companyData.social_media && 
                 Array.isArray(companyData.social_media) && 
                 companyData.social_media.length > 0 ? (
                  companyData.social_media.map((social, index) => (
                    <p key={index} className="company-social-item">
                      <strong>{social.label || "Social Media"}:</strong>{" "}
                      <a
                        href={social.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {social.link || "No link"}
                      </a>
                    </p>
                  ))
                ) : (
                  <p>No social media links</p>
                )}
              </div>
              <div className="company-products col-md-6">
                <h6 className="company-section-title">Products/Services</h6>
                {companyData.products && 
                 Array.isArray(companyData.products) && 
                 companyData.products.length > 0 ? (
                  companyData.products.map((product, index) => (
                    <div key={index} className="company-product-item mb-2">
                      <strong>Product {index + 1}:</strong> {product.text || "No description"}
                      {product.image && (
                        <div className="mt-1">
                          <img
                            src={getImageUrl(product.image)}
                            alt={`Product ${index + 1}`}
                            className="img-fluid rounded"
                            style={{ maxHeight: "100px" }}
                          />
                        </div>
                      )}
                    </div>
                  ))
                ) : (
                  <p>No products/services listed</p>
                )}
              </div>
            </div>

            {companyData.related_companies &&
              Array.isArray(companyData.related_companies) &&
              companyData.related_companies.length > 0 && (
                <div className="company-related mt-4">
                  <h6 className="company-section-title">Related Companies</h6>
                  <div className="row">
                    {companyData.related_companies.map((related, index) => (
                      <div key={index} className="col-md-4 mb-3">
                        <div className="card">
                          <div className="card-body">
                            <h6>{related.company_name || "Related Company"}</h6>
                            <p className="small text-muted">
                              {related.category_name && Array.isArray(related.category_name) 
                                ? related.category_name.join(", ")
                                : "No categories"}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

            {companyData.images &&
              Array.isArray(companyData.images) &&
              companyData.images.length > 0 && (
                <div className="company-images mt-4">
                  <h6 className="company-section-title">Company Images</h6>
                  <div className="row">
                    {companyData.images.map((image, index) => (
                      <div key={index} className="col-md-3 mb-3">
                        <img
                          src={getImageUrl(image)}
                          alt={`Company ${index + 1}`}
                          className="img-fluid rounded"
                          style={{ maxHeight: "150px", objectFit: "cover" }}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              )}

            {/* {companyData.map_link && (
              <div className="company-map mt-4">
                <h6 className="company-section-title">Location</h6>
                <div className="ratio ratio-16x9">
                  <iframe
                    src={companyData.map_link}
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Company Location"
                  ></iframe>
                </div>
              </div>
            )} */}
            {/* {companyData.map_link && (
  <div className="company-map mt-4">
    <h6 className="company-section-title">Location</h6>
    <div className="ratio ratio-16x9">
      <iframe
        src={getEmbedUrl(companyData.map_link)}
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Company Location"
      ></iframe>
    </div>
  </div>
)} */}
{companyData.map_link && (
  <div className="company-map mt-4">
    <h6 className="company-section-title">Location</h6>
    {getEmbedUrl(companyData.map_link) ? (
      <div className="ratio ratio-16x9">
        <iframe
          src={getEmbedUrl(companyData.map_link)}
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Company Location"
        ></iframe>
      </div>
    ) : (
      <div className="card">
        <div className="card-body">
          <div className="d-flex align-items-center">
            <i className="bi bi-geo-alt-fill text-primary me-3" style={{ fontSize: '2rem' }}></i>
            <div>
              <p className="mb-1">
                <strong>Location Map</strong>
              </p>
              <p className="text-muted small mb-2">
                This is a sharing link. Click the button below to open in Google Maps.
              </p>
              <a 
                href={companyData.map_link} 
                target="_blank" 
                rel="noopener noreferrer"
                className="btn btn-outline-primary btn-sm"
              >
                <i className="bi bi-box-arrow-up-right me-1"></i>
                Open in Google Maps
              </a>
            </div>
          </div>
          <div className="mt-2">
            <small className="text-muted">
              <i className="bi bi-info-circle me-1"></i>
              To embed map directly, please use the embed link format (starts with https://www.google.com/maps/embed...)
            </small>
          </div>
        </div>
      </div>
    )}
  </div>
)}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="company-container container-fluid mt-4">
      <div className="company-header row">
        <div className="col-12">
          <div className="company-header-content d-flex justify-content-between align-items-center mb-4">
            <h1 className="company-title h2">
              {hasCompany ? "Edit Company Details" : "Add Company Details"}
            </h1>
            {hasCompany && (
              <button
                className="company-btn company-btn-secondary"
                onClick={handleEditToggle}
              >
                Cancel Edit
              </button>
            )}
          </div>
        </div>
      </div>

      {message && (
        <div
          className={`company-alert alert ${
            message.includes("Please select") ? "alert-warning" : "alert-info"
          } alert-dismissible fade show`}
          role="alert"
        >
          {message}
          <button
            type="button"
            className="btn-close"
            onClick={() => setMessage("")}
          ></button>
        </div>
      )}

      <div className="company-form row">
        <div className="company-sidebar col-md-3">
          <div className="company-nav-card card">
            <div className="company-nav-header card-header">
              <h5 className="company-nav-title card-title mb-0">Navigation</h5>
            </div>
            <div className="company-nav-list list-group list-group-flush">
              <button
                className={`company-nav-item list-group-item list-group-item-action ${
                  activeTab === "basic" ? "active" : ""
                }`}
                onClick={() => setActiveTab("basic")}
              >
                Basic Information
              </button>
              <button
                className={`company-nav-item list-group-item list-group-item-action ${
                  activeTab === "ceo" ? "active" : ""
                }`}
                onClick={() => setActiveTab("ceo")}
              >
                CEO & Contact Info
              </button>
              <button
                className={`company-nav-item list-group-item list-group-item-action ${
                  activeTab === "categories" ? "active" : ""
                }`}
                onClick={() => setActiveTab("categories")}
              >
                Categories
              </button>
              <button
                className={`company-nav-item list-group-item list-group-item-action ${
                  activeTab === "contacts" ? "active" : ""
                }`}
                onClick={() => setActiveTab("contacts")}
              >
                Additional Contacts
              </button>
              <button
                className={`company-nav-item list-group-item list-group-item-action ${
                  activeTab === "social" ? "active" : ""
                }`}
                onClick={() => setActiveTab("social")}
              >
                Social Media
              </button>
              <button
                className={`company-nav-item list-group-item list-group-item-action ${
                  activeTab === "products" ? "active" : ""
                }`}
                onClick={() => setActiveTab("products")}
              >
                Products
              </button>
              <button
                className={`company-nav-item list-group-item list-group-item-action ${
                  activeTab === "images" ? "active" : ""
                }`}
                onClick={() => setActiveTab("images")}
              >
                Images
              </button>
            </div>
          </div>
        </div>

        <div className="company-form-content col-md-9">
          <div className="company-form-card card">
            <div className="company-form-header card-header">
              <h5 className="company-form-title card-title mb-0">
                {activeTab === "basic" && "Basic Information"}
                {activeTab === "ceo" && "CEO & Contact Person Information"}
                {activeTab === "categories" && "Categories & Subcategories"}
                {activeTab === "contacts" && "Additional Contacts"}
                {activeTab === "social" && "Social Media Links"}
                {activeTab === "products" && "Products"}
                {activeTab === "images" && "Company Images"}
              </h5>
            </div>
            <div className="company-form-body card-body">
              <form onSubmit={handleSubmit}>
                {activeTab === "basic" && (
                  <div className="company-tab-content">
                    <div className="company-form-row row mb-3">
                      <div className="col-md-6">
                        <label
                          htmlFor="description"
                          className="company-form-label form-label"
                        >
                          Company Description
                        </label>
                        <textarea
                          className="company-form-textarea form-control"
                          id="description"
                          name="description"
                          rows="3"
                          value={formData.description}
                          onChange={handleChange}
                          placeholder="Describe your company and services..."
                        ></textarea>
                      </div>
                      <div className="col-md-6">
                        <label
                          htmlFor="company_address"
                          className="company-form-label form-label"
                        >
                          Company Address *
                        </label>
                        <textarea
                          className="company-form-textarea form-control"
                          id="company_address"
                          name="company_address"
                          rows="2"
                          value={formData.company_address}
                          onChange={handleChange}
                          required
                        ></textarea>
                      </div>
                    </div>

                    <div className="company-form-row row mb-3">
                      <div className="col-md-6">
                        <label
                          htmlFor="website"
                          className="company-form-label form-label"
                        >
                          Website
                        </label>
                        <input
                          type="text"
                          className="company-form-input form-control"
                          id="website"
                          name="website"
                          value={formData.website}
                          onChange={handleChange}
                          placeholder="https://example.com"
                        />
                      </div>
                      <div className="col-md-6">
                        <label
                          htmlFor="business_hours"
                          className="company-form-label form-label"
                        >
                          Business Hours
                        </label>
                        <input
                          type="text"
                          className="company-form-input form-control"
                          id="business_hours"
                          name="business_hours"
                          value={formData.business_hours}
                          onChange={handleChange}
                          placeholder="Mon-Fri 9AM-6PM"
                        />
                      </div>
                    </div>

                    {/* <div className="company-form-field mb-3">
                      <label
                        htmlFor="map_link"
                        className="company-form-label form-label"
                      >
                        Google Maps Embed Link
                      </label>
                      <input
                        type="text"
                        className="company-form-input form-control"
                        id="map_link"
                        name="map_link"
                        value={formData.map_link}
                        onChange={handleChange}
                        placeholder="https://maps.google.com/embed?pb=..."
                      />
                    </div> */}
                    <div className="company-form-field mb-3">
  <label
    htmlFor="map_link"
    className="company-form-label form-label"
  >
    Google Maps Location
  </label>
  <input
    type="text"
    className="company-form-input form-control"
    id="map_link"
    name="map_link"
    value={formData.map_link}
    onChange={handleChange}
    placeholder="https://www.google.com/maps/embed?pb=... OR https://goo.gl/maps/..."
  />
  <div className="mt-3 p-3 bg-light rounded">
    <small className="text-muted d-block mb-2">
      <strong>📌 adding maps:</strong>
    </small>
    
  
    
    <div>
    
      <ol className="small mb-0 ps-3">
        <li>Go to <a href="https://maps.google.com" target="_blank" rel="noopener noreferrer">Google Maps</a></li>
        <li>Search for your location</li>
        <li>Click the "Share" button</li>
        <li>Select the <strong>"Send a link"</strong> tab</li>
        <li>Copy the link and paste it here</li>
      </ol>
      <div className="alert alert-info mt-2 mb-0 py-2">
        <i className="bi bi-info-circle me-1"></i>
        <small>Note: Sharing links will open in a new tab instead of showing directly on the page.</small>
      </div>
    </div>
  </div>
</div>
                  </div>
                )}

                {activeTab === "ceo" && (
                  <div className="company-tab-content">
                    <div className="company-form-row row mb-3">
                      <div className="col-md-6">
                        <label
                          htmlFor="ceo_name"
                          className="company-form-label form-label"
                        >
                          CEO Name
                        </label>
                        <input
                          type="text"
                          className="company-form-input form-control"
                          id="ceo_name"
                          name="ceo_name"
                          value={formData.ceo_name}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-md-6">
                        <label
                          htmlFor="ceo_mobile"
                          className="company-form-label form-label"
                        >
                          CEO Mobile
                        </label>
                        <input
                          type="text"
                          className="company-form-input form-control"
                          id="ceo_mobile"
                          name="ceo_mobile"
                          value={formData.ceo_mobile}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="company-form-row row mb-3">
                      <div className="col-md-6">
                        <label
                          htmlFor="ceo_mail"
                          className="company-form-label form-label"
                        >
                          CEO Email
                        </label>
                        <input
                          type="email"
                          className="company-form-input form-control"
                          id="ceo_mail"
                          name="ceo_mail"
                          value={formData.ceo_mail}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-md-6">
                        <label
                          htmlFor="ceo_image"
                          className="company-form-label form-label"
                        >
                          CEO Photo
                        </label>
                        <input
                          type="file"
                          className="company-form-input form-control"
                          id="ceo_image"
                          accept="image/*"
                          onChange={(e) => handleImageUpload(e, "ceo_image")}
                        />
                        {imagePreviews.ceo_image && (
                          <div className="mt-2">
                            <small className="text-muted d-block">Current Preview:</small>
                            <img
                              src={imagePreviews.ceo_image}
                              alt="CEO Preview"
                              className="img-thumbnail mt-1"
                              style={{ maxHeight: "100px" }}
                            />
                          </div>
                        )}
                      </div>
                    </div>

                    <hr />

                    <div className="company-form-row row mb-3">
                      <div className="col-md-6">
                        <label
                          htmlFor="contact_person_name"
                          className="company-form-label form-label"
                        >
                          Contact Person Name
                        </label>
                        <input
                          type="text"
                          className="company-form-input form-control"
                          id="contact_person_name"
                          name="contact_person_name"
                          value={formData.contact_person_name}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-md-6">
                        <label
                          htmlFor="contact_person_mobile"
                          className="company-form-label form-label"
                        >
                          Contact Person Mobile
                        </label>
                        <input
                          type="text"
                          className="company-form-input form-control"
                          id="contact_person_mobile"
                          name="contact_person_mobile"
                          value={formData.contact_person_mobile}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="company-form-field mb-3">
                      <label
                        htmlFor="contact_person_mail"
                        className="company-form-label form-label"
                      >
                        Contact Person Email
                      </label>
                      <input
                        type="email"
                        className="company-form-input form-control"
                        id="contact_person_mail"
                        name="contact_person_mail"
                        value={formData.contact_person_mail}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                )}

                {activeTab === "categories" && (
                  <div className="company-tab-content">
                    <div className="company-alert alert alert-info mb-3">
                      <i className="bi bi-info-circle"></i> Please select at
                      least one category. Use Ctrl/Cmd to select multiple
                      options.
                    </div>
                    <div className="company-form-row row mb-3">
                      <div className="col-md-6">
                        <label
                          htmlFor="category"
                          className="company-form-label form-label"
                        >
                          Categories *
                        </label>
                        <select
                          multiple
                          className="company-form-select form-control"
                          id="category"
                          name="category"
                          value={selectedCategories}
                          onChange={handleCategoryChange}
                          required
                          size="5"
                        >
                          {categories.map((cat) => (
                            <option
                              key={cat.category_id}
                              value={cat.category_id}
                            >
                              {cat.name}
                            </option>
                          ))}
                        </select>
                        <small className="company-form-help form-text text-muted">
                          Hold Ctrl/Cmd to select multiple categories
                        </small>
                      </div>
                      <div className="col-md-6">
                        <label
                          htmlFor="subcategory"
                          className="company-form-label form-label"
                        >
                          Subcategories
                        </label>
                        <select
                          multiple
                          className="company-form-select form-control"
                          id="subcategory"
                          name="subcategory"
                          value={selectedSubcategories}
                          onChange={handleSubcategoryChange}
                          size="5"
                        >
                          {subcategories.map((sub) => (
                            <option key={sub.id} value={sub.id}>
                              {sub.name}
                            </option>
                          ))}
                        </select>
                        <small className="company-form-help form-text text-muted">
                          Hold Ctrl/Cmd to select multiple subcategories
                        </small>
                      </div>
                    </div>
                    <div className="company-alert alert alert-info">
                      <i className="bi bi-info-circle"></i> Selected Categories:{" "}
                      {selectedCategories
                        .map((id) => {
                          const cat = categories.find(
                            (c) => c.category_id === id,
                          );
                          return cat ? cat.name : null;
                        })
                        .filter(Boolean)
                        .join(", ") || "None"}
                    </div>
                    <div className="company-alert alert alert-info">
                      <i className="bi bi-info-circle"></i> Selected
                      Subcategories:{" "}
                      {selectedSubcategories
                        .map((id) => {
                          const sub = subcategories.find((s) => s.id === id);
                          return sub ? sub.name : null;
                        })
                        .filter(Boolean)
                        .join(", ") || "None"}
                    </div>
                  </div>
                )}

                {activeTab === "contacts" && (
                  <div className="company-tab-content">
                    <div className="company-form-field mb-3">
                      <label className="company-form-label form-label">
                        Additional Contact Numbers
                      </label>
                      {formData.other_contacts.map((contact, index) => (
                        <div
                          key={index}
                          className="company-contact-field row mb-2"
                        >
                          <div className="col-md-5">
                            <input
                              type="text"
                              className="company-form-input form-control"
                              placeholder="Label (e.g., Manager, Support)"
                              value={contact.label}
                              onChange={(e) =>
                                handleContactChange(
                                  index,
                                  "label",
                                  e.target.value,
                                )
                              }
                            />
                          </div>
                          <div className="col-md-5">
                            <input
                              type="text"
                              className="company-form-input form-control"
                              placeholder="Phone number"
                              value={contact.number}
                              onChange={(e) =>
                                handleContactChange(
                                  index,
                                  "number",
                                  e.target.value,
                                )
                              }
                            />
                          </div>
                          <div className="col-md-2">
                            <button
                              type="button"
                              className="company-btn company-btn-danger w-100"
                              onClick={() => removeContactField(index)}
                              disabled={formData.other_contacts.length <= 1}
                            >
                              Remove
                            </button>
                          </div>
                        </div>
                      ))}
                      <button
                        type="button"
                        className="company-btn company-btn-outline mt-2"
                        onClick={addContactField}
                      >
                        + Add Another Contact
                      </button>
                    </div>
                  </div>
                )}

                {activeTab === "social" && (
                  <div className="company-tab-content">
                    <div className="company-form-field mb-3">
                      <label className="company-form-label form-label">
                        Social Media Links
                      </label>
                      {formData.social_media.map((social, index) => (
                        <div
                          key={index}
                          className="company-social-field row mb-2"
                        >
                          <div className="col-md-5">
                            <select
                              className="company-form-select form-control"
                              value={social.label}
                              onChange={(e) =>
                                handleSocialMediaChange(
                                  index,
                                  "label",
                                  e.target.value,
                                )
                              }
                            >
                              <option value="">Select Platform</option>
                              <option value="Facebook">Facebook</option>
                              <option value="LinkedIn">LinkedIn</option>
                              <option value="Twitter">Twitter</option>
                              <option value="Instagram">Instagram</option>
                              <option value="YouTube">YouTube</option>
                              <option value="WhatsApp">WhatsApp</option>
                              <option value="Telegram">Telegram</option>
                              <option value="Other">Other</option>
                            </select>
                          </div>
                          <div className="col-md-5">
                            <input
                              type="text"
                              className="company-form-input form-control"
                              placeholder="Profile URL"
                              value={social.link}
                              onChange={(e) =>
                                handleSocialMediaChange(
                                  index,
                                  "link",
                                  e.target.value,
                                )
                              }
                            />
                          </div>
                          <div className="col-md-2">
                            <button
                              type="button"
                              className="company-btn company-btn-danger w-100"
                              onClick={() => removeSocialMediaField(index)}
                              disabled={formData.social_media.length <= 1}
                            >
                              Remove
                            </button>
                          </div>
                        </div>
                      ))}
                      <button
                        type="button"
                        className="company-btn company-btn-outline mt-2"
                        onClick={addSocialMediaField}
                      >
                        + Add Another Social Media
                      </button>
                    </div>
                  </div>
                )}

                {activeTab === "products" && (
                  <div className="company-tab-content">
                    <div className="company-form-field mb-3">
                      <label className="company-form-label form-label">
                        Products/Services
                      </label>
                      {formData.products.map((product, index) => (
                        <div
                          key={index}
                          className="company-product-card card mb-3"
                        >
                          <div className="company-product-body card-body">
                            <div className="company-product-row row mb-2">
                              <div className="col-md-10">
                                <label className="company-form-label form-label">
                                  Product Description
                                </label>
                                <textarea
                                  className="company-form-textarea form-control"
                                  rows="2"
                                  placeholder="Describe your product or service..."
                                  value={product.text}
                                  onChange={(e) =>
                                    handleProductChange(
                                      index,
                                      "text",
                                      e.target.value,
                                    )
                                  }
                                ></textarea>
                              </div>
                              <div className="col-md-2 d-flex align-items-end">
                                <button
                                  type="button"
                                  className="company-btn company-btn-danger w-100"
                                  onClick={() => removeProductField(index)}
                                  disabled={formData.products.length <= 1}
                                >
                                  Remove
                                </button>
                              </div>
                            </div>
                            <div className="company-product-row row">
                              <div className="col-md-12">
                                <label className="company-form-label form-label">
                                  Product Image
                                </label>
                                <input
                                  type="file"
                                  className="company-form-input form-control"
                                  accept="image/*"
                                  onChange={(e) =>
                                    handleProductImageUpload(e, index)
                                  }
                                />
                                {imagePreviews.product_images[index] && (
                                  <div className="mt-2">
                                    <small className="text-muted d-block">
                                      {imageFiles.product_images[index] 
                                        ? "New Upload Preview" 
                                        : "Existing Image"}
                                    </small>
                                    <img
                                      src={imagePreviews.product_images[index]}
                                      alt={`Product ${index + 1} Preview`}
                                      className="img-thumbnail mt-1"
                                      style={{ maxHeight: "100px" }}
                                    />
                                  </div>
                                )}
                                {!imagePreviews.product_images[index] && existingProductImages[index] && (
                                  <div className="mt-2">
                                    <small className="text-muted d-block">Existing Image (will be preserved if not changed)</small>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                      <button
                        type="button"
                        className="company-btn company-btn-outline mt-2"
                        onClick={addProductField}
                      >
                        + Add Another Product
                      </button>
                    </div>
                  </div>
                )}

                {activeTab === "images" && (
                  <div className="company-tab-content">
                    <div className="company-form-field mb-3">
                      <label className="company-form-label form-label">
                        Company Images
                      </label>
                      <div className="company-images-upload mb-3">
                        <input
                          type="file"
                          className="company-form-input form-control"
                          accept="image/*"
                          multiple
                          onChange={(e) => handleImageUpload(e, "images")}
                        />
                        <small className="form-text text-muted">
                          Upload multiple images of your company
                        </small>
                      </div>

                      {imagePreviews.company_images.length > 0 && (
                        <div className="company-images-preview mt-3">
                          <h6 className="company-section-title">
                            Image Previews
                          </h6>
                          <div className="row">
                            {imagePreviews.company_images.map((preview, index) => (
                              <div key={index} className="col-md-3 mb-3">
                                <div className="image-preview-container position-relative">
                                  <img
                                    src={preview}
                                    alt={`Preview ${index + 1}`}
                                    className="img-fluid rounded"
                                    style={{ maxHeight: "150px", objectFit: "cover" }}
                                  />
                                  <button
                                    type="button"
                                    className="btn-close position-absolute top-0 end-0 m-1 bg-white rounded-circle p-1"
                                    onClick={() => removeImage(index)}
                                  ></button>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                <div className="company-form-actions d-flex justify-content-between mt-4">
                  <div>
                    {activeTab !== "basic" && (
                      <button
                        type="button"
                        className="company-btn company-btn-secondary me-2"
                        onClick={() => {
                          const tabs = [
                            "basic",
                            "ceo",
                            "categories",
                            "contacts",
                            "social",
                            "products",
                            "images",
                          ];
                          const currentIndex = tabs.indexOf(activeTab);
                          if (currentIndex > 0)
                            setActiveTab(tabs[currentIndex - 1]);
                        }}
                      >
                        Previous
                      </button>
                    )}
                    {activeTab !== "images" && (
                      <button
                        type="button"
                        className="company-btn company-btn-primary"
                        onClick={() => {
                          const tabs = [
                            "basic",
                            "ceo",
                            "categories",
                            "contacts",
                            "social",
                            "products",
                            "images",
                          ];
                          const currentIndex = tabs.indexOf(activeTab);
                          if (currentIndex < tabs.length - 1)
                            setActiveTab(tabs[currentIndex + 1]);
                        }}
                      >
                        Next
                      </button>
                    )}
                  </div>
                  <button
                    type="submit"
                    className="company-btn company-btn-success"
                    disabled={loading}
                  >
                    {loading
                      ? "Saving..."
                      : hasCompany
                        ? "Update Company"
                        : "Add Company"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyDetails;